<template>
  <b-col md="4">
    <b-overlay :show="showOverlay" rounded="sm">
      <!-- <b-card>backComponentName: {{backComponentName}}</b-card>
      <b-card>copyComponentName: {{copyComponentName}}</b-card>
      <b-card>isComplaintGrp: {{isComplaintGrp}}</b-card> 
      <b-card>IsUse_Tab3: {{IsUse_Tab3}}</b-card>
      <b-card>isProcessAvailable: {{complaintGroupIsProcessAvailable}}</b-card>
      <b-card>isEnable: {{isEnable}}</b-card> -->

      <b-card class="mb-2">
        <b-tabs>
          <!-- ดำเนินการ -->
          <b-tab
            v-if="
              backComponentName !== 'ClueSearch' &&
                (backComponentName === 'screening' ||
                  backComponentName === 'Officer' ||
                  backComponentName === 'LawOfficer' ||
                  isDepartmentValid()) &&
                backComponentName !== 'MainSearch' &&
                backComponentName !== 'ComplaintHistory' &&
                backComponentName !== 'BangkokOfficerHistory'
            "
            id="tab-right-1"
            title="ดำเนินการ"
            @click="onMainTabClicked(0)"
          >
            <b-row v-if="onFastTrack === false">
              <b-col cols="12" class="ml-0">
                <b-tabs>
                  <b-tab
                    v-for="item in bTabs"
                    :key="item.tab.id"
                    :id="'tab-sub-' + item.tab.id"
                    :title="item.tab.name"
                    @click="onSubTabClicked(item.tab.id)"
                  >
                    <b-row>
                      <fieldset
                        class="border pb-2 col-12"
                        v-if="
                          similarComplaintData !== null &&
                            similarComplaintData.length > 0
                        "
                      >
                        <div class="ml-2 mt-2" style="font-size:1rem;">
                          <span class="text-danger"
                            >เรื่องร้องทุกข์ซ้ำซ้อนกับเรื่องร้องทุกข์
                          </span>
                          <span
                            v-for="(simComp, index) in similarComplaintData"
                            :key="simComp.complaintId"
                            class="text-danger"
                            >{{ index === 0 ? " " : ", "
                            }}{{ simComp.complaintCode }}
                          </span>
                        </div>
                      </fieldset>

                      <fieldset
                        class="border pb-2 col-12"
                        v-if="
                          item.statusModel.filter((value) => {
                            return (
                              value.statusID >= 5000 && value.statusID < 6000
                            );
                          }).length > 0
                        "
                      >
                        <legend class="w-auto" style="font-size:1rem;">
                          <span class="text-danger">AI แนะนำเจ้าหน้าที่</span>
                        </legend>

                        <b-col
                          v-for="rad in item.statusModel.filter((value) => {
                            return (
                              value.statusID >= 5000 && value.statusID < 6000
                            );
                          })"
                          :key="rad.statusID"
                          cols="12"
                          class="mt-1"
                        >
                          <!-- 5000 = ชำนาญ, 5100 = การเวียน, 5200 - 6000 = ตามปริมาณ -->
                          <span
                            v-if="rad.statusID === 5000"
                            class="pb-1 text-bold"
                          >
                            ตามความชำนาญ
                          </span>
                          <span
                            v-else-if="rad.statusID === 5100"
                            class="pb-1 text-bold"
                          >
                            ตามการเวียนดำเนินการ
                          </span>
                          <span
                            v-else-if="rad.statusID === 5200"
                            class="pb-1 text-bold"
                          >
                            ตามปริมาณงานที่ค้างดำเนินการ
                          </span>
                          <b-form-radio
                            v-model="item.selectedStatus"
                            :value="rad.statusID"
                            @change="onStatusChange(rad.statusID, item.tab.id)"
                          >
                            {{ rad.description }}
                          </b-form-radio>
                        </b-col>
                      </fieldset>

                      <!-- normal status range is 0 - 4999 -->
                      <b-col
                        v-for="rad in item.statusModel.filter((value) => {
                          return value.statusID < 5000;
                        })"
                        :key="rad.statusID"
                        cols="12"
                        class="mt-1 pl-2"
                      >
                        <fieldset
                          class="border pl-1 pr-1 pb-1"
                          v-if="rad.statusID === 999"
                        >
                          <legend class="w-auto" style="font-size:1rem;">
                            <span class="text-danger">** แนะนำโดย AI</span>
                          </legend>
                          <b-form-radio
                            v-model="item.selectedStatus"
                            :value="rad.statusID"
                            @change="onStatusChange(rad.statusID, item.tab.id)"
                          >
                            {{ rad.description }}
                          </b-form-radio>
                        </fieldset>

                        <fieldset
                          class="border border-dark border-custom-dark pl-1 pr-1 pb-1"
                          v-else-if="rad.statusID === 316"
                        >
                          <legend class="w-auto pb-2" style="font-size:1rem;">
                            <span class=""></span>
                          </legend>
                          <b-form-radio
                            v-model="item.selectedStatus"
                            :value="rad.statusID"
                            :disabled="isDocumentInProgress(item, rad)"
                            @change="onStatusChange(rad.statusID, item.tab.id)"
                          >
                            <b
                              v-if="rad.docCode !== null"
                              style="color: #7367f0 !important;"
                            >
                              {{
                                statusDescriptionRemoveNumber(rad.description)
                              }}
                            </b>
                            <b v-else>
                              {{
                                statusDescriptionRemoveNumber(rad.description)
                              }}
                            </b>

                            <small v-if="rad.formID !== null">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="#000000"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              >
                                <path
                                  d="M20 11.08V8l-6-6H6a2 2 0 0 0-2 2v16c0 1.1.9 2 2 2h6"
                                />
                                <path d="M14 3v5h5M18 21v-6M15 18h6" />
                              </svg>
                            </small>

                            <small
                              class="tooltip"
                              v-if="
                                rad.statusID === 11 ||
                                  rad.statusID === 31 ||
                                  rad.statusID === 81
                              "
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              >
                                <path
                                  d="M12 2a10 10 0 1 0 0 20a10 10 0 0 0 0-20zm0 14v-4m0-4h.01"
                                />
                              </svg>

                              <span class="tooltip-text">
                                หน่วยงานที่เชื่อมโยงเมื่อบันทึกสถานะสำเร็จระบบจะส่งเรื่องร้องทุกข์ให้หน่วยงานผ่านระบบ
                                โดยไม่ต้องทำหนังสืออิเล็กทรอนิกส์
                              </span>
                            </small>
                            <small
                              class="custom-tooltip"
                              v-if="rad.statusID === 605"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              >
                                <path
                                  d="M12 2a10 10 0 1 0 0 20a10 10 0 0 0 0-20zm0 14v-4m0-4h.01"
                                />
                              </svg>

                              <span class="tooltip-text">
                                ระบบจะดำเนินการสร้างเลขรับแจ้งใหม่และส่งให้ระบบการเฝ้าระวังฯ
                                (OCPB Care)
                                เพื่อดำเนินการพิจารณาต่อโดยเรื่องร้องทุกข์จะยังสามารถดำเนินการต่อในระบบร้องทุกข์ได้
                              </span>
                            </small>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                            ></svg>

                            <a
                              v-if="rad.docCode !== null"
                              style="color: #7367f0 !important;"
                              @click="getDocHistory(rad.docID)"
                            >
                              ({{ rad.docCode }})</a
                            >
                          </b-form-radio>
                        </fieldset>

                        <b-form-radio
                          v-else
                          v-model="item.selectedStatus"
                          :value="rad.statusID"
                          :disabled="
                            isDocumentInProgress(item, rad) ||
                              rad.disableMe === true
                          "
                          @change="onStatusChange(rad.statusID, item.tab.id)"
                        >
                          <b
                            v-if="rad.docCode !== null"
                            style="color: #7367f0 !important;"
                          >
                            {{ rad.description }}
                          </b>
                          <b v-else>
                            {{ rad.description }}
                          </b>

                          <small v-if="rad.formID !== null">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#000000"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            >
                              <path
                                d="M20 11.08V8l-6-6H6a2 2 0 0 0-2 2v16c0 1.1.9 2 2 2h6"
                              />
                              <path d="M14 3v5h5M18 21v-6M15 18h6" />
                            </svg>
                          </small>

                          <small
                            class="tooltip"
                            v-if="
                              rad.statusID === 11 ||
                                rad.statusID === 31 ||
                                rad.statusID === 81
                            "
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            >
                              <path
                                d="M12 2a10 10 0 1 0 0 20a10 10 0 0 0 0-20zm0 14v-4m0-4h.01"
                              />
                            </svg>

                            <span class="tooltip-text">
                              หน่วยงานที่เชื่อมโยงเมื่อบันทึกสถานะสำเร็จระบบจะส่งเรื่องร้องทุกข์ให้หน่วยงานผ่านระบบ
                              โดยไม่ต้องทำหนังสืออิเล็กทรอนิกส์
                            </span>
                          </small>
                          <small
                            class="custom-tooltip"
                            v-if="rad.statusID === 605"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            >
                              <path
                                d="M12 2a10 10 0 1 0 0 20a10 10 0 0 0 0-20zm0 14v-4m0-4h.01"
                              />
                            </svg>

                            <span class="tooltip-text">
                              ระบบจะดำเนินการสร้างเลขรับแจ้งใหม่และส่งให้ระบบการเฝ้าระวังฯ
                              (OCPB Care)
                              เพื่อดำเนินการพิจารณาต่อโดยเรื่องร้องทุกข์จะยังสามารถดำเนินการต่อในระบบร้องทุกข์ได้
                            </span>
                          </small>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                          ></svg>

                          <a
                            v-if="rad.docCode !== null"
                            style="color: #7367f0 !important;"
                            @click="getDocHistory(rad.docID)"
                          >
                            ({{ rad.docCode }})</a
                          >
                        </b-form-radio>

                        <div
                          class="ml-3 text-muted"
                          v-if="getStatusHistory(rad.statusID).length > 0"
                        >
                          (
                          <span
                            class=""
                            v-for="(statusDate, indexDate) in getStatusHistory(
                              rad.statusID,
                              rad.statusID,
                            )"
                            :key="indexDate"
                          >
                            <span v-if="indexDate !== 0">,</span>
                            {{ statusDate.createTrackingDateStr }}

                            <span
                              v-if="
                                statusDate.comment !== undefined &&
                                  statusDate.comment !== null &&
                                  statusDate.comment !== ''
                              "
                            >
                              - {{ statusDate.comment }}
                            </span>
                          </span>
                          )
                          <a
                            href="javascript:void(0)"
                            v-if="rad.showMeeting === true"
                            @click="onAppointmentMediateClick(rad.meeting)"
                            ><feather-icon
                              icon="VideoIcon"
                              size="28"
                            ></feather-icon
                          ></a>
                        </div>
                        <label
                          class="d-block mt-1 pl-1"
                          v-if="
                            rad.showOption === true &&
                              (rad.statusID == 514 || rad.statusID == 518)
                          "
                        >
                          ผู้ประกอบการ
                        </label>
                        <multiselect
                          class="mt-1"
                          v-if="
                            rad.showOption === true && rad.isMultiple === true
                          "
                          :required="true"
                          track-by="text"
                          label="text"
                          v-model="rad.selectedOption"
                          :options="rad.selectOptions"
                          @input="selectOnInput"
                          :multiple="true"
                        >
                        </multiselect>
                        <vue-select
                          v-else-if="
                            rad.showOption === true &&
                              (rad.statusID == 514 || rad.statusID == 518)
                          "
                          label="text"
                          :required="true"
                          v-model="rad.selectedOption"
                          :options="rad.selectOptions"
                          @input="selectOnInput"
                          class="pl-1"
                        />
                        <vue-select
                          v-else-if="rad.showOption === true"
                          label="text"
                          :required="true"
                          v-model="rad.selectedOption"
                          :options="rad.selectOptions"
                          @input="selectOnInput"
                          class="mt-1 pl-1"
                        />
                        <!--Select option 2-->
                        <label
                          class="d-block mt-1 pl-1"
                          v-if="rad.showOption2 === true"
                        >
                          หน่วยงานภายใน
                        </label>
                        <vue-select
                          v-if="rad.showOption2 === true"
                          label="text"
                          :required="true"
                          v-model="rad.selectedOption2"
                          :options="rad.selectOptions2"
                          @input="selectOnInput"
                          class="pl-1"
                        />

                        <b-col
                          cols="12 mt-2"
                          v-if="
                            rad.showOption === true &&
                              rad.selectedOption !== null &&
                              (rad.selectedOption.provincialLevel > 0 ||
                                isDetrctProvincalLevel(rad.selectedOption) > 0)
                          "
                        >
                          จังหวัด
                          <vue-select
                            label="text"
                            v-model="extendProvinceSelected"
                            :options="extendProvinceOptions"
                            @input="selectExtendStatusProcessProvinceInput"
                            class="mt-1 pl-1"
                          />
                        </b-col>
                        <b-col
                          cols="12 mt-2"
                          v-if="
                            rad.showOption === true &&
                              rad.selectedOption !== null &&
                              (rad.selectedOption.provincialLevel > 1 ||
                                isDetrctProvincalLevel(rad.selectedOption) > 1)
                          "
                        >
                          อำเภอ
                          **ถ้าต้องการส่งข้อมูลไปที่จังหวัดไม่ต้องเลือกอำเภอ
                          <vue-select
                            label="text"
                            v-model="extendDistrictSelected"
                            :options="extendDistrictOptions"
                            @input="selectExtendStatusProcessDistrictInput"
                            class="mt-1 pl-1"
                          />
                        </b-col>
                      </b-col>
                    </b-row>
                  </b-tab>
                </b-tabs>
              </b-col>

              <!-- ความเห็นเจ้าหน้าที่ -->
              <b-col>
                <b-col
                  v-if="
                    backComponentName === 'MainSearch' ||
                      backComponentName === 'ComplaintHistory'
                  "
                >
                </b-col>

                <b-col v-else cols="12 mt-2">
                  <b-form-group
                    label="ความเห็นเจ้าหน้าที่"
                    label-for="offficerComment"
                  >
                    <b-form-textarea
                      id="offficerComment"
                      placeholder="ความเห็นเจ้าหน้าที่"
                      rows="6"
                      v-model="comment"
                    />
                  </b-form-group>

                  <b-row
                    v-for="file in this.additionalFilesForDisplay"
                    :key="file.attachId"
                    class="col-12 m-1 "
                  >
                    <b-col md="10">
                      <a
                        :href="file.filePath"
                        :download="file.fileName"
                        target="_blank"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24px"
                          height="24px"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="feather feather-arrow-down-circle"
                        >
                          <circle cx="12" cy="12" r="10" />
                          <polyline points="8 12 12 16 16 12" />
                          <line x1="12" y1="8" x2="12" y2="16" />
                        </svg>
                        {{ file.fileName }}
                        <br />
                        /{{ file.masterDescription }}
                      </a>
                    </b-col>
                    <b-col md="2" class="d-flex justify-content-center">
                      <a
                        href="javascript:void(0)"
                        class="text-danger"
                        @click="onAdditionalAttachFileDelete(file.attachId)"
                      >
                        <feather-icon icon="Trash2Icon" size="24" />
                      </a>
                    </b-col>
                  </b-row>

                  <!--  -->

                  <b-form-group
                    v-if="isShowAdditionalFile()"
                    label="เอกสารจากผู้ร้อง"
                    label-for="file-input3"
                    class="mt-1"
                  >
                    <b-overlay :show="file3Overlay" rounded="sm">
                      <b-form-select
                        v-model="selected"
                        :options="attachTypes"
                        class="mb-1"
                      />
                      <b-form-file
                        @change="onUploadFileChangedAdditional"
                        ref="file-input3"
                        multiple
                        placeholder="Choose a file or drop it here..."
                        drop-placeholder="Drop file here..."
                      />
                    </b-overlay>
                  </b-form-group>

                  <b-row
                    v-for="file in this.filterAttachFile(4)"
                    :key="file.attachId"
                    class="col-12 m-1 "
                  >
                    <b-col md="10">
                      <a
                        :href="file.filePath"
                        :download="file.fileName"
                        target="_blank"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24px"
                          height="24px"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="feather feather-arrow-down-circle"
                        >
                          <circle cx="12" cy="12" r="10" />
                          <polyline points="8 12 12 16 16 12" />
                          <line x1="12" y1="8" x2="12" y2="16" />
                        </svg>
                        {{ file.fileName }}
                      </a>
                    </b-col>
                    <b-col md="2" class="d-flex justify-content-center">
                      <a
                        href="javascript:void(0)"
                        class="text-danger"
                        @click="onAttachFileDelete(file.attachId)"
                      >
                        <feather-icon icon="Trash2Icon" size="24" />
                      </a>
                    </b-col>
                  </b-row>

                  <!--  -->

                  <b-form-group
                    label="เอกสารประกอบเรื่องร้องเรียน"
                    label-for="file-input2"
                    class="mt-1"
                  >
                    <b-overlay :show="file2Overlay" rounded="sm">
                      <b-form-file
                        @change="onUploadFileChangedType4"
                        ref="file-input"
                        multiple
                        placeholder="Choose a file or drop it here..."
                        drop-placeholder="Drop file here..."
                      />
                    </b-overlay>
                  </b-form-group>
                </b-col>
              </b-col>

              <!-- ปุ่มบันทึก / ปุ่มยกเลิก -->
              <b-col cols="12" class="d-flex justify-content-between mt-2">
                <b-button variant="secondary" @click="onBackBtnClicked">
                  ยกเลิก
                </b-button>
                <b-button
                  variant="primary"
                  @click="onSubmitBtnCliked"
                  :enabled="isEnable"
                >
                  บันทึก
                </b-button>
              </b-col>
            </b-row>
            <b-row v-else>
              <div
                class="container d-flex align-items-center"
                style="min-height:400px;"
              >
                <div class="row w-100">
                  <div class="col text-center">
                    <h4 class="text-danger">
                      เรื่องกำลังถูกดำเนินการโดยผู้ประกอบการ
                    </h4>
                  </div>
                </div>
              </div>
            </b-row>
          </b-tab>

          <!-- ยุติ - บันทึกมูลค่าความเสียหาย - Case :=>  MainSearch / CompalintHistory -->
          <b-tab
            v-if="backComponentName === 'ComplaintHistory'"
            id="tab-right-1"
            title="ยุติ"
          >
            <b-row>
              <!-- บันทึกมูลค่าความเสียหาย -->
              <b-col cols="12" class="ml-0">
                <b-col
                  v-for="rad in bTabs[0].statusModel.filter((value) => {
                    return value.statusID < 5000;
                  })"
                  :key="rad.statusID"
                  cols="12"
                  class="mt-1 pl-2"
                >
                  <fieldset
                    v-if="rad.statusID === 316"
                    class="border border-dark border-custom-dark pl-1 pr-1 pb-1"
                  >
                    <legend class="w-auto pb-2" style="font-size:1rem;">
                      <span class=""></span>
                    </legend>
                    <b-form-radio
                      v-model="bTabs[0].selectedStatus"
                      :value="rad.statusID"
                      :disabled="isDocumentInProgress(bTabs[0], rad)"
                      @change="onStatusChange(rad.statusID, bTabs[0].tab.id)"
                    >
                      <b
                        v-if="rad.docCode !== null"
                        style="color: #7367f0 !important;"
                      >
                        {{ statusDescriptionRemoveNumber(rad.description) }}
                      </b>
                      <b v-else>
                        {{ statusDescriptionRemoveNumber(rad.description) }}
                      </b>

                      <small v-if="rad.formID !== null">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#000000"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        >
                          <path
                            d="M20 11.08V8l-6-6H6a2 2 0 0 0-2 2v16c0 1.1.9 2 2 2h6"
                          />
                          <path d="M14 3v5h5M18 21v-6M15 18h6" />
                        </svg>
                      </small>

                      <small
                        class="tooltip"
                        v-if="
                          rad.statusID === 11 ||
                            rad.statusID === 31 ||
                            rad.statusID === 81
                        "
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        >
                          <path
                            d="M12 2a10 10 0 1 0 0 20a10 10 0 0 0 0-20zm0 14v-4m0-4h.01"
                          />
                        </svg>

                        <span class="tooltip-text">
                          หน่วยงานที่เชื่อมโยงเมื่อบันทึกสถานะสำเร็จระบบจะส่งเรื่องร้องทุกข์ให้หน่วยงานผ่านระบบ
                          โดยไม่ต้องทำหนังสืออิเล็กทรอนิกส์
                        </span>
                      </small>
                      <small class="custom-tooltip" v-if="rad.statusID === 605">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        >
                          <path
                            d="M12 2a10 10 0 1 0 0 20a10 10 0 0 0 0-20zm0 14v-4m0-4h.01"
                          />
                        </svg>

                        <span class="tooltip-text">
                          ระบบจะดำเนินการสร้างเลขรับแจ้งใหม่และส่งให้ระบบการเฝ้าระวังฯ
                          (OCPB Care)
                          เพื่อดำเนินการพิจารณาต่อโดยเรื่องร้องทุกข์จะยังสามารถดำเนินการต่อในระบบร้องทุกข์ได้
                        </span>
                      </small>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                      ></svg>

                      <a
                        v-if="rad.docCode !== null"
                        style="color: #7367f0 !important;"
                        @click="getDocHistory(rad.docID)"
                      >
                        ({{ rad.docCode }})</a
                      >
                    </b-form-radio>
                  </fieldset>
                  <b-form-radio
                    v-else
                    v-model="bTabs[0].selectedStatus"
                    :value="rad.statusID"
                    :disabled="isDocumentInProgress(bTabs[0], rad)"
                    @change="onStatusChange(rad.statusID, bTabs[0].tab.id)"
                  >
                    <b
                      v-if="rad.docCode !== null"
                      style="color: #7367f0 !important;"
                    >
                      {{ rad.description }}
                    </b>
                    <b v-else>
                      {{ rad.description }}
                    </b>

                    <small v-if="rad.formID !== null">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#000000"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path
                          d="M20 11.08V8l-6-6H6a2 2 0 0 0-2 2v16c0 1.1.9 2 2 2h6"
                        />
                        <path d="M14 3v5h5M18 21v-6M15 18h6" />
                      </svg>
                    </small>

                    <small
                      class="tooltip"
                      v-if="
                        rad.statusID === 11 ||
                          rad.statusID === 31 ||
                          rad.statusID === 81
                      "
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path
                          d="M12 2a10 10 0 1 0 0 20a10 10 0 0 0 0-20zm0 14v-4m0-4h.01"
                        />
                      </svg>

                      <span class="tooltip-text">
                        หน่วยงานที่เชื่อมโยงเมื่อบันทึกสถานะสำเร็จระบบจะส่งเรื่องร้องทุกข์ให้หน่วยงานผ่านระบบ
                        โดยไม่ต้องทำหนังสืออิเล็กทรอนิกส์
                      </span>
                    </small>
                    <small class="custom-tooltip" v-if="rad.statusID === 605">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path
                          d="M12 2a10 10 0 1 0 0 20a10 10 0 0 0 0-20zm0 14v-4m0-4h.01"
                        />
                      </svg>

                      <span class="tooltip-text">
                        ระบบจะดำเนินการสร้างเลขรับแจ้งใหม่และส่งให้ระบบการเฝ้าระวังฯ
                        (OCPB Care)
                        เพื่อดำเนินการพิจารณาต่อโดยเรื่องร้องทุกข์จะยังสามารถดำเนินการต่อในระบบร้องทุกข์ได้
                      </span>
                    </small>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    ></svg>

                    <a
                      v-if="rad.docCode !== null"
                      style="color: #7367f0 !important;"
                      @click="getDocHistory(rad.docID)"
                    >
                      ({{ rad.docCode }})</a
                    >
                  </b-form-radio>
                  <div
                    class="ml-3 text-muted"
                    v-if="getStatusHistory(rad.statusID).length > 0"
                  >
                    (
                    <span
                      class=""
                      v-for="(statusDate, indexDate) in getStatusHistory(
                        rad.statusID,
                      )"
                      :key="indexDate"
                    >
                      <span v-if="indexDate !== 0">,</span>
                      {{ statusDate.createTrackingDateStr }}

                      <span
                        v-if="
                          statusDate.comment !== undefined &&
                            statusDate.comment !== null &&
                            statusDate.comment !== ''
                        "
                      >
                        - {{ statusDate.comment }}
                      </span>
                    </span>
                    )
                  </div>

                  <vue-select
                    v-if="rad.showOption === true"
                    label="text"
                    :required="true"
                    v-model="rad.selectedOption"
                    :options="rad.selectOptions"
                    @input="selectOnInput"
                    class="mt-1 pl-1"
                  />
                </b-col>
              </b-col>

              <!-- ปุ่มบันทึก / ปุ่มยกเลิก -->
              <b-col
                v-if="backComponentName === 'ComplaintHistory'"
                cols="12"
                class="d-flex justify-content-between mt-2"
              >
                <b-button variant="secondary" @click="onBackBtnClicked">
                  ยกเลิก
                </b-button>
                <b-button
                  variant="primary"
                  @click="onSubmitBtnCliked"
                  :enabled="isEnable"
                >
                  บันทึก
                </b-button>
              </b-col>
              <b-col
                v-else
                cols="12"
                class="d-flex justify-content-between mt-2"
              >
                <b-button variant="secondary" @click="onBackBtnClicked">
                  ยกเลิก
                </b-button>
              </b-col>
              <!-- <b-col cols="12" class="d-flex justify-content-between mt-2">
                <b-button variant="secondary" @click="onBackBtnClicked">
                  ยกเลิก
                </b-button>
                <b-button v-if="backComponentName === 'ComplaintHistory'">
                  <b-button variant="primary" @click="onSubmitBtnCliked">
                    บันทึก
                  </b-button>
                </b-button>
              </b-col> -->
            </b-row>
          </b-tab>

          <!-- ประวัติ -->
          <b-tab id="tab-right-2" title="ประวัติ">
            <b-row>
              <b-col
                v-for="(item, i) in trackings"
                :key="item.trackingId"
                cols="12"
                class="list-group list-group-circle text-left m-1"
              >
                <div class="d-flex list-group-item">
                  <div class="">
                    <h5 class="mb-0">
                      {{ i + 1 }}. {{ item.name }}
                      <span
                        v-if="
                          item.provincename != null &&
                            item.departmentId !== bangkokDepartmentId
                        "
                        >{{ item.provincename }}
                      </span>
                      <span v-if="item.districtName != null"
                        >{{ item.districtName }}
                      </span>
                      <span v-if="item.subDistrictName != null">{{
                        item.subDistrictName
                      }}</span>
                    </h5>
                    <!-- <small class="text-muted">{{ item.createTracking }}</small> -->
                  </div>
                  <div class="col ml-auto">
                    <hr class="my-12 bg-dark" />
                  </div>
                </div>

                <div
                  v-for="(item2, index2) in item.detailList"
                  :key="index2"
                  class="d-flex justify-content-round ml-2 mr-5"
                >
                  <div
                    v-for="(item3, index3) in item2.lv"
                    :key="index3"
                    class="w-100"
                  >
                    <!-- <div class="d-flex justify-content-between mb-1">
                    <span></span>
                    <small class="mb-0">{{ item2.createTrackingStr }}</small>
                  </div>
                  <div class="d-flex justify-content-between mb-1">
                    <span class="mb-0">
                      {{ item3.description }}
                      <span v-for="(item4, index4) in item3.st" :key="index4">
                        {{ item4.stDes }}
                      </span>
                    </span>
                  </div> -->

                    <div class="d-flex justify-content-between ml-2">
                      <span class="mb-0">
                        {{ index2 + 1 }} ) {{ item3.description }} :
                        <span v-for="(item4, index4) in item3.st" :key="index4">
                          {{ item4.stDes }}

                          <!-- <b-btutton
                            v-if="item4.statusID === 514"
                            style="color: #7367f0 !important;"
                            class="btn btn-outline-primary btn-sm ml-2"
                            @click="getFasttrackHistory(item2.trackingDetailId)"
                          >
                            ดูสถานะการทำงาน</b-btutton
                          >-->
                        </span>
                      </span>
                    </div>

                    <div class="d-flex justify-content-between ml-2 text-left">
                      <small class="mb-0"> {{ item2.createTrackingStr }}</small>
                      <small
                        v-for="(item4, index4) in item3.st"
                        :key="index4"
                        class="d-flex justify-content-between ml-2"
                      >
                        <span v-for="(item5, index5) in item4.u" :key="index5">
                          <b> {{ item5.fName }} {{ item5.lName }} </b>

                          <span
                            v-for="(item6, index6) in item5.u2"
                            :key="index6"
                          >
                            <b v-if="item6.fName != null">
                              ส่งต่อ {{ item6.fName }} {{ item6.lName }}</b
                            >
                          </span>
                        </span>
                      </small>
                    </div>

                    <div
                      class="d-flex justify-content-between ml-2"
                      v-if="item2.comment"
                    >
                      <span class="mb-0">
                        <b> ความคิดเห็น : </b> {{ item2.comment }}
                      </span>
                    </div>

                    <div
                      v-for="(item4, index4) in item3.st"
                      :key="`warn-${index4}`"
                      class="d-flex justify-content-between ml-2"
                    >
                      <OcpbCareTrackingButton
                        v-if="item4.statusID === 605"
                        :comment="item2.comment"
                      />
                    </div>

                    <div
                      v-for="(item4, index4) in item3.st"
                      :key="`warn-${index4}`"
                      class="d-flex justify-content-between ml-2"
                    >
                      <span v-if="item4.statusID === 517" class="mb-0 text-danger">
                        กรุณายืนยันการยุติเรื่องจากบริษัทภายใน 15 วันนับจากวันที่ได้รับแจ้ง หากพ้นกำหนดระยะเวลาดังกล่าว ระบบจะดำเนินการยุติเรื่องโดยอัตโนมัติ
                      </span>
                    </div>
                    <!-- fastTrack begin  : loop for display attachFiles in object  -->
                    <b-row
                      v-for="(file, index) in item2.attachFiles"
                      :key="index"
                      class="col-12 m-1 "
                    >
                      <b-col md="12">
                        <a
                          href="javacript:void(0)"
                          @click="
                            downloadFasttrackAttachFile(file, item2.companyId)
                          "
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24px"
                            height="24px"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="feather feather-arrow-down-circle"
                          >
                            <circle cx="12" cy="12" r="10" />
                            <polyline points="8 12 12 16 16 12" />
                            <line x1="12" y1="8" x2="12" y2="16" />
                          </svg>
                          {{ file.fileName }}
                        </a>
                      </b-col>
                    </b-row>
                    <!-- fastTrack end  : loop for display attachFiles in object  -->
                    <b-row
                      v-for="file in filterTrackingDetailAttachFile(
                        item2.trackingDetailId,
                      )"
                      :key="file.attachId"
                      class="col-12 m-1 "
                    >
                      <b-col md="12">
                        <a
                          :href="file.filePath"
                          :download="file.fileName"
                          target="_blank"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24px"
                            height="24px"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="feather feather-arrow-down-circle"
                          >
                            <circle cx="12" cy="12" r="10" />
                            <polyline points="8 12 12 16 16 12" />
                            <line x1="12" y1="8" x2="12" y2="16" />
                          </svg>
                          {{ file.fileName }}
                        </a>
                      </b-col>
                    </b-row>

                    <hr class="my-12 bg-dark w-100" />
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-tab>

          <!-- บันทึกสถานะ -->
          <b-tab
            v-if="
              IsUse_Tab3 === true &&
                (backComponentName === 'screening' ||
                  backComponentName === 'Officer' ||
                  backComponentName === 'LawOfficer' ||
                  isDepartmentValid())
            "
            id="tab-right-3"
            title="บันทึกสถานะ"
            @click="onMainTabClicked(1)"
          >
            <b-row v-if="onFastTrack === false">
              <b-col cols="12 mt-1">
                ชั้นดำเนินการ
                <vue-select
                  label="maingroup"
                  v-model="categoryProcess"
                  :options="categoryProcessOptions"
                  @input="selectOnInputCategoryProcess"
                  class="mt-1 pl-1"
                />
              </b-col>

              <b-col cols="12 mt-1" v-if="categoryProcess !== null">
                สถานะ
                <vue-select
                  label="group"
                  v-model="groupProcess"
                  :options="categoryProcess.actionAllModel"
                  @input="selectOnInputGroupProcess"
                  class="mt-1 pl-1 "
                />
              </b-col>

              <b-col cols="12 mt-2" v-if="groupProcess !== null">
                สถานะย่อย
                <vue-select
                  label="description"
                  v-model="statusProcess"
                  :options="groupProcess.statuses"
                  @input="selectOnInputStatusProcess"
                  class="mt-1 pl-1"
                />
              </b-col>

              <b-col
                cols="12 mt-2"
                v-if="
                  statusProcess !== null &&
                    statusProcess.showOption === true &&
                    statusProcess !== null
                "
              >
                {{ statusProcess.description }}
                <vue-select
                  label="text"
                  v-model="extendStatusProcess"
                  :options="extendStatusProcessOptions"
                  @input="selectExtendStatusProcessInput"
                  class="mt-1 pl-1"
                />
              </b-col>

              <b-col
                cols="12 mt-2"
                v-if="
                  statusProcess !== null &&
                    statusProcess.showOption === true &&
                    statusProcess !== null &&
                    extendStatusProcess !== null &&
                    extendStatusProcess.provincialLevel > 0
                "
              >
                จังหวัด
                <vue-select
                  label="text"
                  v-model="extendProvinceSelected"
                  :options="extendProvinceOptions"
                  @input="selectExtendStatusProcessProvinceInput"
                  class="mt-1 pl-1"
                />
              </b-col>

              <b-col
                cols="12 mt-2"
                v-if="
                  statusProcess !== null &&
                    statusProcess.showOption === true &&
                    statusProcess !== null &&
                    extendStatusProcess !== null &&
                    extendStatusProcess.provincialLevel > 1
                "
              >
                อำเภอ **ถ้าต้องการส่งข้อมูลไปที่จังหวัดไม่ต้องเลือกอำเภอ
                <vue-select
                  label="text"
                  v-model="extendDistrictSelected"
                  :options="extendDistrictOptions"
                  @input="selectExtendStatusProcessDistrictInput"
                  class="mt-1 pl-1"
                />
              </b-col>

              <b-col cols="12 mt-2">
                <b-form-group
                  label="ความเห็นเจ้าหน้าที่"
                  label-for="offficerComment"
                >
                  <b-form-textarea
                    id="offficerComment"
                    placeholder="ความเห็นเจ้าหน้าที่"
                    rows="6"
                    v-model="comment"
                  />
                </b-form-group>

                <b-row
                  v-for="file in this.filterAttachFile(3)"
                  :key="file.attachId"
                  class="col-12 m-1"
                >
                  <b-col md="10">
                    <a
                      :href="file.filePath"
                      :download="file.fileName"
                      target="_blank"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24px"
                        height="24px"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="feather feather-arrow-down-circle"
                      >
                        <circle cx="12" cy="12" r="10" />
                        <polyline points="8 12 12 16 16 12" />
                        <line x1="12" y1="8" x2="12" y2="16" />
                      </svg>
                      {{ file.fileName }}
                    </a>
                  </b-col>
                  <b-col md="2" class="d-flex justify-content-center">
                    <a
                      href="javascript:void(0)"
                      class="text-danger"
                      @click="onAttachFileDelete(file.attachId)"
                    >
                      <feather-icon icon="Trash2Icon" size="24" />
                    </a>
                  </b-col>
                </b-row>

                <b-form-group
                  label="หนังสือประกอบสถานะดำเนินงาน"
                  label-for="file-input"
                  class="mt-1"
                >
                  <b-overlay :show="file1Overlay" rounded="sm">
                    <b-form-file
                      @change="onUploadFileChangedType3"
                      id="file-input"
                      ref="file-input"
                      multiple
                      placeholder="Choose a file or drop it here..."
                      drop-placeholder="Drop file here..."
                    />
                  </b-overlay>
                </b-form-group>

                <b-row
                  v-for="file in this.filterAttachFile(4)"
                  :key="file.attachId"
                  class="col-12 m-1"
                >
                  <b-col md="10">
                    <a
                      :href="file.filePath"
                      :download="file.fileName"
                      target="_blank"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24px"
                        height="24px"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="feather feather-arrow-down-circle"
                      >
                        <circle cx="12" cy="12" r="10" />
                        <polyline points="8 12 12 16 16 12" />
                        <line x1="12" y1="8" x2="12" y2="16" />
                      </svg>
                      {{ file.fileName }}
                    </a>
                  </b-col>
                  <b-col md="2" class="d-flex justify-content-center">
                    <a
                      href="javascript:void(0)"
                      class="text-danger"
                      @click="onAttachFileDelete(file.attachId)"
                    >
                      <feather-icon icon="Trash2Icon" size="24" />
                    </a>
                  </b-col>
                </b-row>

                <b-form-group
                  label="เอกสารประกอบเรื่องร้องเรียน"
                  label-for="file-input2"
                  class="mt-1"
                >
                  <b-overlay :show="file2Overlay" rounded="sm">
                    <b-form-file
                      @change="onUploadFileChangedType4"
                      id="file-input2"
                      ref="file-input2"
                      multiple
                      placeholder="Choose a file or drop it here..."
                      drop-placeholder="Drop file here..."
                    />
                  </b-overlay>
                </b-form-group>
              </b-col>

              <b-col cols="12" class="d-flex justify-content-between mt-2">
                <b-button variant="secondary" @click="onBackBtnClicked">
                  ยกเลิก
                </b-button>
                <b-button
                  variant="primary"
                  @click="onSubmitBtnCliked_Tab3"
                  :enabled="isEnable"
                >
                  บันทึก
                </b-button>
              </b-col>
            </b-row>
            <b-row v-else>
              <div
                class="container d-flex align-items-center"
                style="min-height:400px;"
              >
                <div class="row w-100">
                  <div class="col text-center">
                    <h4 class="text-danger">
                      เรื่องกำลังถูกดำเนินการโดยผู้ประกอบการ
                    </h4>
                  </div>
                </div>
              </div>
            </b-row>
          </b-tab>
        </b-tabs>
      </b-card>

      <ModalDocHistory
        ref="modal-doc-history"
        :docHistoryDetail="docHistoryDetail"
      />

      <ModalMediateAppointmentDetail ref="modal-mediate-appointment-detail" />

      <ModalFasttrackHistory
        ref="modal-fasttrack-history"
        :fasttrackHistoryDetail="fasttrackHistoryDetail"
      />

    </b-overlay>
  </b-col>
</template>

<script>
import {
  BRow,
  BCol,
  BFormTextarea,
  BFormGroup,
  BFormInput,
  BTab,
  BTabs,
  BCard,
  BFormRadioGroup,
  BFormSelect,
  BFormFile,
  BButton,
  BFormRadio,
  BOverlay,
} from "bootstrap-vue";

//import * as storeGeneral from "@/store/api/general/index.js";

import VueSelect from "vue-select";

import ModalDocHistory from "./ModalDocHistory.vue";
import OcpbCareTrackingButton from "./OcpbCareTrackingButton.vue";
import ModalMediateAppointmentDetail from "./ModalMediateAppointmentDetail.vue";

import * as storeComplaint from "@/store/api/complaint/complaint.js";
import * as storeStatus from "@/store/api/status/index.js";
import * as storeTracking from "@/store/api/tracking/index.js";
import * as storeClue from "@/store/api/clue/index.js";

import * as storeFileUpload from "@/store/api/fileUpload/index.js";
import * as storeMaster from "@/store/api/master/index.js";
import * as storeDocument from "@/store/api/document/index.js";

import * as departmentRoleStore from "@/store/api/role/departmentRole.js";

import * as storeComplaintGroup from "@/store/api/complaint/complaintGroup.js";
import * as userData from "@/auth/localStorageUtils.js";
import appsettings from "@/store/app-settings";
import Multiselect from "vue-multiselect";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import ModalFasttrackHistory from "./ModalFasttrackHistory.vue";
import ConclusionDetail from "../Conclusion/ConclusionDetail.vue";

// import { v4 as uuidv4 } from 'uuid'

export default {
  components: {
    BRow,
    BCol,
    BFormTextarea,
    BFormGroup,
    BFormInput,
    BTab,
    BTabs,
    BCard,
    BFormRadioGroup,
    BFormSelect,
    BFormFile,
    BButton,
    BFormRadio,
    storeComplaint,
    storeStatus,
    userData,
    VueSelect,
    ModalDocHistory,
    OcpbCareTrackingButton,
    ModalMediateAppointmentDetail,
    ModalFasttrackHistory,
    BOverlay,
    Multiselect,
    FeatherIcon,
  },
  props: {
    destination: Array,
    complaintId: "",
    levelId: "",
    redirectComponentName: "",
    backComponentName: "",
    copyComponentName: "",
    updateProcessName: "",
    IsUse_Tab3: {
      type: Boolean,
      required: false,
      default: false,
    },
    clueId: "",
    isClue: {
      type: Boolean,
      required: false,
      default: false,
    },
    // isClue: false,

    isComplaintGrp: false,
    complaintGroupId: "",
    complaintGroupIsProcessAvailable: true,
    complainantCompany: {},
    complaintData: {},
    personals: [],
    attorneys: [],
  },
  data() {
    return {
      attachFiles: [],
      comment: "",
      selectedTab: 0,
      bTabs: [],
      trackings: [],
      categoryProcess: null,
      categoryProcessOptions: [],
      statusProcess: null,
      statusProcessOptions: [],
      groupProcess: null,
      extendStatusProcess: null,
      extendStatusProcessOptions: [],
      extendStatusProcessSelected: null,
      extendProvinceOptions: [],
      extendProvinceSelected: null,
      extendDistrictOptions: [],
      extendDistrictSelected: null,
      aiDepartment: null,
      docHistoryDetail: [],
      fasttrackHistoryDetail: [],
      trackingDetailAttachFiles: [],
      file1Overlay: false,
      file2Overlay: false,
      file3Overlay: false,
      attachTypes: [],
      additionalAttachFiles: [],
      selected: 13,
      lastTrackingData: null,
      similarComplaintData: [],
      showOverlay: false,
      department: {
        value: userData.selectedAdminDepartment(),
        text: "",
      },
      isEnable: true,
      lawLegalDepartment: "0351CA3F-4D3C-4FD0-B82E-5A5B0DC1E224",
      lawLegalExecutionDepartment: "A74DBA00-A697-4906-9125-260C8955275D",
      comment27:
        "โดยมีหนังสือแจ้งผลให้ผู้ร้องทราบผลมติคณะกรรมการคุ้มครองผู้บริโภค",
      tabIndex: 0,
      tabIndexdetail: 0,
      onFastTrack: false,
      bangkokDepartmentId: appsettings.bangkokDepartmentId,
    };
  },
  created() {
    if (this.isClue === false) {
      //console.log"เรื่องร้องทุกข์");
      this.loadStatusData();
      this.loadTrackingData();
      this.loadTrackingDetailAttachFiles();
      this.getFileType();
      this.getLastTracking(this.complaintId);
      // console.log("this.backComponentName", this.backComponentName);
      if (this.backComponentName === "screening") {
        this.getSimilarComplaint(this.complaintId);
      } else if (this.backComponentName === "Deptlist") {
        this.loadAIOfficer();
      }
    } else {
      //console.log"เรื่องแจ้งเบาะแส");
      this.loadStatusData();
      this.loadClueTrackingData();
      this.loadClueTrackingDetailAttachFiles();
      this.getFileType();
      this.getClueLastTracking(this.clueId);
    }

    this.getExtendProvinces();
  },
  computed: {
    additionalFilesForDisplay() {
      if (this.isShowAdditionalFile()) {
        return this.additionalAttachFiles;
      } else {
        return [];
      }
    },
  },
  watch: {
    bTabs() {
      //console.log"watch", this.bTabs);
      // console.log("watch", this.bTabs);
    },
  },
  methods: {
    loadStatusData(level = null, companyName = null, complaintDetail = null) {
      const _this = this;

      // Validate ปุ่มการใช้งานตามสถานะ IsProcessAvailable [รอติวดำเนินการ]
      _this.isEnable = this.complaintGroupIsProcessAvailable;

      if (this.updateProcessName == "MenuGroup") {
        storeStatus
          .getStatusMenuGroup(userData.departmentId(), _this.$route.query.id)
          .then(function(response) {
            // handle success
            // //console.log"then", response);
            _this.bTabs = response.data.data;

            const currentTab = _this.bTabs.find(function(value) {
              return value.tab.id === 0;
            });

            let currentStatus = currentTab.statusModel[0];

            // try {
            //   _this.onStatusChange(currentStatus.statusID, 0);
            // } catch (ex) {}
          })
          .catch(function(error) {
            // handle error
            //console.log"error", error);
          });
      } else if (this.backComponentName == "screening") {
        if (this.isComplaintGrp == true) {
          //console.log"screening แบบกลุ่ม", this.isComplaintGrp);
          // console.log("screening แบบกลุ่ม", this.isComplaintGrp);

          storeComplaintGroup
            .getStatusMenu(userData.departmentId(), _this.$route.query.id)
            .then(function(response) {
              _this.bTabs = response.data.data;

              //console.log"screening แบบกลุ่ม", response.data.data);
              // console.log("screening แบบกลุ่ม", response.data.data);

              const currentTab = _this.bTabs.find(function(value) {
                return value.tab.id === 0;
              });

              let currentStatus = currentTab.statusModel[0];

              if (companyName !== null || complaintDetail !== null) {
                _this.loadAiDepartment(companyName, complaintDetail);
              }
            })
            .catch(function(error) {
              // handle error
              //console.log"error", error);
            });
        } else {
          storeStatus
            .getStatusMenu(userData.departmentId(), _this.$route.query.id)
            .then(function(response) {
              _this.bTabs = response.data.data;

              const currentTab = _this.bTabs.find(function(value) {
                return value.tab.id === 0;
              });

              let currentStatus = currentTab.statusModel[0];

              if (companyName !== null || complaintDetail !== null) {
                _this.loadAiDepartment(companyName, complaintDetail);
              }
            })
            .catch(function(error) {
              //console.log"error", error);
            });
        }
        // storeStatus
        //   .getStatusMenu(userData.departmentId(), _this.$route.query.id)
        //   .then(function(response) {
        //     // handle success
        //     // //console.log"then", response);
        //     _this.bTabs = response.data.data;

        //     const currentTab = _this.bTabs.find(function(value) {
        //       return value.tab.id === 0;
        //     });

        //     let currentStatus = currentTab.statusModel[0];

        //     // try {
        //     //   _this.onStatusChange(currentStatus.statusID, 0);
        //     // } catch (ex) {}

        //     if (companyName !== null || complaintDetail !== null) {
        //       _this.loadAiDepartment(companyName, complaintDetail);
        //     }
        //   })
        //   .catch(function(error) {
        //     // handle error
        //     //console.log"error", error);
        //   });
      } else if (this.backComponentName == "Deptlist") {
        storeStatus
          .GetDeptStatusMenu(userData.departmentId(), _this.$route.query.id)
          .then(function(response) {
            // handle success
            // //console.log"then", response);
            _this.bTabs = response.data.data;

            const currentTab = _this.bTabs.find(function(value) {
              return value.tab.id === 0;
            });

            let currentStatus = currentTab.statusModel[0];

            // try {
            //   _this.onStatusChange(currentStatus.statusID, 0);
            // } catch (ex) {}

            _this.loadAIOfficer();
          })
          .catch(function(error) {
            // handle error
            //console.log"error", error);
          });
      } else if (this.backComponentName === "Officer") {
        if (this.isComplaintGrp == true) {
          //console.log"Officer แบบกลุ่ม");
          //console.log"Officer แบบกลุ่ม departmentId", userData.departmentId());
          //console.log
          //   "Officer แบบกลุ่ม $route.query.id",
          //   _this.$route.query.id
          // console.log("Officer แบบกลุ่ม");
          // console.log("Officer แบบกลุ่ม departmentId", userData.departmentId());
          // console.log(
          //   "Officer แบบกลุ่ม $route.query.id",
          //   _this.$route.query.id,
          // );

          storeComplaintGroup
            .getOfficerStatusMenu(
              userData.departmentId(),
              _this.$route.query.id,
            )
            .then(function(response) {
              //console.log"Officer แบบกลุ่ม", response.data.data);
              // console.log("Officer แบบกลุ่ม", response.data.data);
              _this.bTabs = response.data.data;
              const currentTab = _this.bTabs.find(function(value) {
                return value.tab.id === 0;
              });

              let currentStatus = currentTab.statusModel[0];
            })
            .catch(function(error) {
              //console.log"error", error);
            });
        } else {
          if (level !== null) {
            storeStatus
              .getOfficerStatusMenu(
                level,
                userData.departmentId(),
                _this.$route.query.id,
              )
              .then(function(response) {
                _this.bTabs = response.data.data;

                const currentTab = _this.bTabs.find(function(value) {
                  return value.tab.id === 0;
                });

                let currentStatus = currentTab.statusModel[0];
              })
              .catch(function(error) {
                //console.log"error", error);
              });
          }
        }
        // if (level !== null) {
        //   storeStatus
        //   .getOfficerStatusMenu(
        //     level,
        //     userData.departmentId(),
        //     _this.$route.query.id
        //   )
        //   .then(function(response) {
        //     // handle success
        //     // //console.log"then", response);
        //     _this.bTabs = response.data.data;

        //     const currentTab = _this.bTabs.find(function(value) {
        //       return value.tab.id === 0;
        //     });

        //     let currentStatus = currentTab.statusModel[0];

        //     // try {
        //     //   _this.onStatusChange(currentStatus.statusID, 0);
        //     // } catch (ex) {}
        //   })
        //   .catch(function(error) {
        //     // handle error
        //     //console.log"error", error);
        //   });
        // }
      } else if (this.backComponentName === "LawOfficer") {
        if (this.isComplaintGrp == true) {
          //console.log"LawOfficer แบบกลุ่ม");
          //console.log
          //   "LawOfficer แบบกลุ่ม departmentId",
          //   userData.departmentId()
          // );
          //console.log
          //   "LawOfficer แบบกลุ่ม $route.query.id",
          //   _this.$route.query.id
          // console.log("LawOfficer แบบกลุ่ม");
          // console.log(
          //   "LawOfficer แบบกลุ่ม departmentId",
          //   userData.departmentId(),
          // );
          // console.log(
          //   "LawOfficer แบบกลุ่ม $route.query.id",
          //   _this.$route.query.id,
          // );

          storeComplaintGroup
            .getLawOfficerStatusMenu(
              userData.departmentId(),
              _this.$route.query.id,
              _this.$route.query.id,
            )
            .then(function(response) {
              //console.log"LawOfficer แบบกลุ่ม", response.data.data);
              // console.log("LawOfficer แบบกลุ่ม", response.data.data);
              _this.bTabs = response.data.data;
              const currentTab = _this.bTabs.find(function(value) {
                return value.tab.id === 0;
              });

              let currentStatus = currentTab.statusModel[0];
            })
            .catch(function(error) {
              //console.log"LawOfficer แบบกลุ่ม", error);
              // //console.log"error", error);
            });
        } else {
          if (level !== null) {
            storeStatus
              .getLawOfficerStatusMenu(
                level,
                userData.departmentId(),
                _this.$route.query.id,
              )
              .then(function(response) {
                _this.bTabs = response.data.data;

                const currentTab = _this.bTabs.find(function(value) {
                  return value.tab.id === 0;
                });

                let currentStatus = currentTab.statusModel[0];
              })
              .catch(function(error) {
                //console.log"error", error);
              });
          }
          // if (level !== null) {
          //   storeStatus
          //   .getLawOfficerStatusMenu(
          //     level,
          //     userData.departmentId(),
          //     _this.$route.query.id
          //   )
          //   .then(function(response) {
          //     // handle success
          //     // //console.log"then", response);
          //     _this.bTabs = response.data.data;

          //     const currentTab = _this.bTabs.find(function(value) {
          //       return value.tab.id === 0;
          //     });

          //     let currentStatus = currentTab.statusModel[0];

          //     // try {
          //     //   _this.onStatusChange(currentStatus.statusID, 0);
          //     // } catch (ex) {}
          //   })
          //   .catch(function(error) {
          //     // handle error
          //     //console.log"error", error);
          //   });
        }
      } else if (this.backComponentName === "LawDeptlist") {
        storeStatus
          .getLegalStatusMenu(userData.departmentId(), _this.$route.query.id)
          .then(function(response) {
            // handle success
            // //console.log"then", response);
            _this.bTabs = response.data.data;

            const currentTab = _this.bTabs.find(function(value) {
              return value.tab.id === 0;
            });

            let currentStatus = currentTab.statusModel[0];

            // try {
            //   _this.onStatusChange(currentStatus.statusID, 0);
            // } catch (ex) {}
            _this.loadAIOfficer();
          })
          .catch(function(error) {
            // handle error
            //console.log"error", error);
          });
      } else if (this.backComponentName === "LawLeaderDept") {
        storeStatus
          .getLeaderLegalStatusMenu(
            userData.departmentId(),
            _this.$route.query.id,
            _this.$route.query.id,
          )
          .then(function(response) {
            // handle success
            // //console.log"then", response);
            _this.bTabs = response.data.data;

            const currentTab = _this.bTabs.find(function(value) {
              return value.tab.id === 0;
            });

            let currentStatus = currentTab.statusModel[0];

            // try {
            //   _this.onStatusChange(currentStatus.statusID, 0);
            // } catch (ex) {}

            _this.loadAIOfficer();
          })
          .catch(function(error) {
            // handle error
            //console.log"error", error);
          });
      } else if (
        this.backComponentName === "ClueCheck" ||
        this.backComponentName === "ClueAction"
      ) {
        //console.log"loadStatusData");
        let searchStatusMenu = 3;
        if (
          userData.departmentId().toLowerCase() ===
            appsettings.clueDepartmentID.screening.toLowerCase() ||
          userData.departmentId().toLowerCase() ===
            appsettings.clueDepartmentID.screeningOld.toLowerCase()
        ) {
          searchStatusMenu = 1;
        }

        storeStatus
          .getClueStatusMenu(searchStatusMenu)
          .then(function(response) {
            // handle success
            // //console.log"then", response);
            _this.bTabs = response.data.data;

            //console.log"loadStatusData 1", response.data.data);
            // console.log("loadStatusData 1", response.data.data);

            const currentTab = _this.bTabs.find(function(value) {
              return value.tab.id === 0;
            });

            //console.log"loadStatusData 2", currentTab);

            let currentStatus = currentTab.statusModel[0];

            //console.log"loadStatusData 3", currentTab);

            // try {
            //   _this.onStatusChange(currentStatus.statusID, 0);
            // } catch (ex) {}
          })
          .catch(function(error) {
            // handle error
            //console.log"error loadStatusData 4", error);
          });
      } else if (this.backComponentName === "ProvinceOfficer") {
        storeStatus
          .getProvinceStatusMenu(_this.complaintId)
          .then(function(response) {
            // handle success
            // //console.log"then", response);
            _this.bTabs = response.data.data;

            const currentTab = _this.bTabs.find(function(value) {
              return value.tab.id === 0;
            });

            let currentStatus = currentTab.statusModel[0];

            // try {
            //   _this.onStatusChange(currentStatus.statusID, 0);
            // } catch (ex) {}
          })
          .catch(function(error) {
            // handle error
            //console.log"error", error);
          });
        ////////////////
        // แจ้งเบาะแส //
      } else if (
        this.backComponentName === "MainSearch" ||
        this.backComponentName === "ComplaintHistory" ||
        this.backComponentName === "BangkokOfficerHistory"
      ) {
        storeStatus
          .getStatusDamage(userData.departmentId(), _this.$route.query.id)
          .then(function(response) {
            // handle success
            //console.log"then", response);
            _this.bTabs = response.data.data;

            //console.log"แสดง _this.bTabs", _this.bTabs);

            const currentTab = _this.bTabs.find(function(value) {
              return value.tab.id === 0;
            });

            let currentStatus = currentTab.statusModel[0];
          })
          .catch(function(error) {
            // handle error
            //console.log"error", error);
          });
      } else if (
        this.backComponentName === "BangkokOfficer" ||
        this.backComponentName === "BangkokOfficerHistory"
      ) {
        storeStatus
          .getBangkokStatusMenu(_this.complaintId)
          .then(function(response) {
            // handle success
            // console.log("then", response);
            _this.bTabs = response.data.data;

            const currentTab = _this.bTabs.find(function(value) {
              return value.tab.id === 0;
            });

            let currentStatus = currentTab.statusModel[0];

            // try {
            //   _this.onStatusChange(currentStatus.statusID, 0);
            // } catch (ex) {}
          })
          .catch(function(error) {
            // handle error
            console.log("error", error);
          });
        ////////////////
        // แจ้งเบาะแส //
      }

      //console.log"ttttt", _this.IsUse_Tab3);
      if (_this.IsUse_Tab3) {
        //tab3
        try {
          let actionType = this.backComponentName;
          if (
            this.copyComponentName === "LawOfficerMange" ||
            this.copyComponentName === "LawOfficerGroupManage"
          ) {
            if (
              userData.selectedAdminDepartment().toUpperCase() ===
              this.lawLegalDepartment
            ) {
              /// กฏหมายและคดี
              actionType = "officerLegal";
            } else {
              /// กฏหมาย-บังคับคดี
              actionType = "officerExecution";
            }
          } else if (this.copyComponentName === "LawDeptlistRecieve") {
            actionType = "adminLegal";
          } else if (this.copyComponentName === "DeptlistRecieve") {
            actionType = "admin";
          }

          if (this.isComplaintGrp === true) {
            storeComplaintGroup
              .getStatusProcess(actionType, "")
              .then(function(response) {
                _this.categoryProcessOptions = response.data.data;
                //console.log"actionType", actionType);
                //console.log"GetStatusProcess", response.data.data);
                // console.log("actionType", actionType);
                // console.log("GetStatusProcess", response.data.data);
                if (actionType === "officerLegal") {
                  _this.setOfficerLegalDefaultTab3Select();
                }
              })
              .catch(function(error) {
                //console.log"error", error);
              });
          } else {
            storeStatus
              .GetStatusProcess(actionType, "")
              .then(function(response) {
                _this.categoryProcessOptions = response.data.data;
                //console.log"actionType", actionType);
                // console.log("actionType", actionType);
                if (actionType === "officerLegal") {
                  _this.setOfficerLegalDefaultTab3Select();
                }
              })
              .catch(function(error) {
                // handle error
                //console.log"error", error);
              });
          }

          // storeStatus
          // .GetStatusProcess(actionType, "")
          // .then(function(response) {
          //   //////console.log"response:",response)
          //   _this.categoryProcessOptions = response.data.data;
          //   //console.log"actionType", actionType);
          //   if (actionType === "officerLegal") {
          //     _this.setOfficerLegalDefaultTab3Select();
          //   }
          // })
          // .catch(function(error) {
          //   // handle error
          //   //console.log"error", error);
          // });
        } catch (ex) {
          //console.log"IsUserTab3", ex);
        }
      }

      //console.log"_this.$props.complaintId", _this.$props.complaintId);
      // console.log("_this.$props.complaintId", _this.$props.complaintId);
    },
    setOfficerLegalDefaultTab3Select() {
      try {
        //console.log
        //   "categoryProcess",
        //   this.categoryProcess,
        //   this.categoryProcessOptions
        // );
        this.categoryProcess = this.categoryProcessOptions[0];
      } catch (ex) {
        //console.log"ex", ex);
      }
    },
    loadAiDepartment(companyName, complaintDetail) {
      const _this = this;
      const params = {
        companyName,
        complaintDetail,
      };
      storeStatus
        .getAiDepartment(params)
        .then((response) => {
          //console.log"get aiDepartment");
          const aiDep = response.data.data;

          if (aiDep.depName.length > 0) {
            const statusAi = {
              description: "ส่งต่อหน่วยงาน" + aiDep.depName[0],
              statusGroup: "ส่งต่อ",
              statusID: 999,
              departmentID: aiDep.depID[0],
              sOrder: 12,
              commonID: null,
              docID: null,
              docCode: null,
            };

            //console.log"_this.bTabs", _this.bTabs);

            _this.bTabs[0].statusModel.push(statusAi);

            //_this.$forceUpdate()
          }
        })
        .catch((err) => {
          //console.log"err", err);
        });
    },
    loadTrackingData() {
      const _this = this;

      if (this.isComplaintGrp == true) {
        //console.log"loadTrackingData แบบกลุ่ม");

        storeComplaintGroup
          .getTracking(_this.$props.complaintId)
          .then((response) => {
            // console.log("loadTrackingData แบบกลุ่ม", response);
            _this.trackings = response.data.data;
          })
          .catch((error) => {
            console.log("error", error);
          });
      } else {
        if (
          this.backComponentName === "BangkokOfficer" ||
          this.backComponentName === "BangkokOfficerHistory"
        ) {
          //console.log("loadTrackingData แบบกทม.");

          storeTracking
            .getBangkokTrackingDetail(_this.$props.complaintId)
            .then((response) => {
              console.log("trackings", response);
              _this.trackings = response.data.data;
            })
            .catch((error) => {
              console.log("error", error);
            });
        } else {
          storeTracking
            .getDocumentTrackingDetail(_this.$props.complaintId)
            .then((response) => {
              // console.log("trackings", response);
              _this.trackings = response.data.data;
            })
            .catch((error) => {
              console.log("error", error);
            });
        }
      }
      // storeTracking
      //   .getDocumentTrackingDetail(_this.$props.complaintId)
      //   .then((response) => {
      //     //console.log"trackings", response);
      //     _this.trackings = response.data.data;
      //   })
      //   .catch((error) => {
      //     //console.log"error", error);
      //   });
    },
    loadClueTrackingData() {
      const _this = this;
      //console.log"loadClueTrackingData");

      storeTracking
        .getClueTrackingDetail(_this.$props.clueId)
        .then((response) => {
          //console.log"getClueTrackingDetail", response);
          // console.log("getClueTrackingDetail", response);
          _this.trackings = response.data.data;
        })
        .catch((error) => {
          //console.log"error", error);
        });
    },
    loadTrackingDetailAttachFiles() {
      const _this = this;
      const params = {
        complaintId: this.$route.query.id,
      };

      storeDocument
        .getComplaintAttachFile(params)
        .then((response) => {
          _this.trackingDetailAttachFiles = response.data.data;
        })
        .catch((error) => {
          //console.log"error", error);
        });
    },
    loadClueTrackingDetailAttachFiles() {
      const _this = this;
      const params = {
        clueId: this.$route.query.id,
      };

      storeDocument
        .getClueAttachFile(params)
        .then((response) => {
          _this.trackingDetailAttachFiles = response.data.data;
        })
        .catch((error) => {
          //console.log"error", error);
        });
    },
    loadAIOfficer() {
      const _this = this;
      const params = {
        departmentId: userData.departmentId(),
        complaintId: this.$route.query.id,
      };
      storeStatus
        .getAiOfficer(params)
        .then((response) => {
          //console.log"get aiOfficer");
          const aiOfficer = response.data.data;

          if (aiOfficer.length > 0) {
            ////console.log'aiOfficer', aiOfficer)

            _this.bTabs[0].statusModel.push(...aiOfficer);

            //_this.$forceUpdate()
          }
        })
        .catch((err) => {
          //console.log"err", err);
        });
    },
    getDocHistory(docId) {
      var _this = this;
      storeDocument
        .GetHistoryDocument(docId)
        .then((response) => {
          _this.docHistoryDetail = response.data.data;

          ////console.log'ref', _this.$refs)
          _this.$refs["modal-doc-history"].$refs["modal-doc-history"].show();
        })
        .catch((error) => {
          //console.log"error", error);
        });
    },
    getFasttrackHistory(trackingDetailId) {
      var _this = this;
      storeTracking
        .getFastTrackTrackingForComplaint(trackingDetailId)
        .then((response) => {
          console.log("response", response.data.data);
          _this.fasttrackHistoryDetail = response.data.data;

          console.log("ref", _this.$refs);
          _this.$refs["modal-fasttrack-history"].$refs[
            "modal-fasttrack-history"
          ].show();
        })
        .catch((error) => {
          //console.log"error", error);
        });
    },
    getFasttrackHistory(trackingDetailId) {
      var _this = this;
      storeTracking
        .getFastTrackTrackingForComplaint(trackingDetailId)
        .then((response) => {
          // console.log("response", response.data.data);
          _this.fasttrackHistoryDetail = response.data.data;

          // console.log("ref", _this.$refs);
          _this.$refs["modal-fasttrack-history"].$refs[
            "modal-fasttrack-history"
          ].show();
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    onSubmitBtnCliked() {
      const _this = this;

      const tab = this.bTabs.find(function(value) {
        return value.tab.id === _this.selectedTab;
      });
      // //console.log"selectedRadio", tab.selectedStatus);

      let currentStatus = tab.statusModel.find(function(value) {
        return value.statusID === tab.selectedStatus;
      });

      if (currentStatus === null || currentStatus === undefined) {
        _this.$bvToast.toast("กรุณาเลือกสถานะที่จะส่งต่อ", {
          title: `เกิดข้อผิดพลาด`,
          variant: "danger",
          solid: false,
        });
        return;
      }
      // console.log("currentStatus", currentStatus);

      // COMPLAINT-818 เช็คเพิ่มเติมว่ามี isMultiple ไหมถ้ามีจะต้องเช็คด้วย
      if (currentStatus.isMultiple === true) {
        // if (
        //   !(
        //     currentStatus.selectedOption &&
        //     currentStatus.selectedOption.length > 0
        //   )
        // )
        let isEmpty = false;
        //การเช็คหน่วยงานกรณีทีที่ส่งต่อหน่วยงานภายนอกเเล้วข้อมูลเป็นทั่ง object เเละ array
        if (Array.isArray(currentStatus.selectedOption)) {
          // ถ้าเป็น array
          isEmpty = currentStatus.selectedOption.length === 0;
        } else {
          // ถ้าเป็น object
          isEmpty =
            !currentStatus.selectedOption ||
            !currentStatus.selectedOption.value;
          console.log("isEmpty", isEmpty);
        }

        if (isEmpty) {
          if (
            currentStatus.statusID === 11 ||
            currentStatus.statusID === 31 ||
            currentStatus.statusID === 504 ||
            currentStatus.statusID === 81
          ) {
            _this.$bvToast.toast("กรุณาเลือกหน่วยงานที่จะส่งต่อ", {
              title: `เกิดข้อผิดพลาด`,
              variant: "danger",
              solid: false,
            });
            return;
          } else {
            _this.$bvToast.toast("กรุณาเลือกข้อมูลให้ครบถ้วน", {
              title: `เกิดข้อผิดพลาด`,
              variant: "danger",
              solid: false,
            });
            return;
          }
        }
      }

      // เช็คว่าตัว extend มี provincialLevel เท่าไหร่
      var isreturn = false;
      if (currentStatus.selectedOption) {
        if (currentStatus.selectedOption.length > 0) {
          currentStatus.selectedOption?.forEach(function(s, i) {
            if (s) {
              // console.log("s", s);
              // 1 จังหวัด
              if (currentStatus.selectedOption[i].provincialLevel > 0) {
                if (_this.extendProvinceSelected) {
                  const pCode = _this.extendProvinceSelected.value;
                  // console.log("pCode", pCode);
                  if (!pCode) {
                    // validate required จังหวัด
                    _this.$bvToast.toast("กรุณาเลือกจังหวัดที่จะส่งต่อ", {
                      title: `เกิดข้อผิดพลาด`,
                      variant: "danger",
                      solid: false,
                    });
                    isreturn = true;
                    /* return ออก loop */
                    return;
                  }
                } else {
                  // validate required จังหวัด
                  _this.$bvToast.toast("กรุณาเลือกจังหวัดที่จะส่งต่อ", {
                    title: `เกิดข้อผิดพลาด`,
                    variant: "danger",
                    solid: false,
                  });
                  isreturn = true;
                  /* return ออก loop */
                  return;
                }
              }
              if (currentStatus.selectedOption[i].provincialLevel > 1) {
                // 2 อำเภอ
                if (_this.extendDistrictSelected) {
                  const dCode = _this.extendDistrictSelected.value;
                }
              }
            }
          });
        }
      }
      /* ถ้าไมีจังหวัดให้เลือกเเล้วไม่ได้เลือกมาจะ return ออก method */
      if (isreturn === true) {
        return;
      }
      // COMPLAINT-1534 กรณีเจ้าหน้าที่เปลี่ยนผู้ประกอบการ ต้องเลือกบริษัทที่เข้าร่วม Fasttrack (MOU) ก่อนจึงจะส่งได้
      if (currentStatus.statusID === 514 || currentStatus.statusID === 518) {
        if (!currentStatus.selectedOption?.compId) {
          _this.$bvToast.toast("กรุณาเลือกผู้ประกอบการที่เข้าร่วม Fasttrack", {
            title: `เกิดข้อผิดพลาด`,
            variant: "danger",
            solid: false,
          });
          return;
        }
      }

      let html = "";
      let fileNames = null;
      if (currentStatus.statusID === 514 || currentStatus.statusID === 518) {
        // COMPLAINT-1534 ถ้าเจ้าหน้าที่เปลี่ยนผู้ประกอบการเป็นรายที่ผู้ร้องไม่ได้แนบข้อมูลคำสั่งซื้อไว้
        // จะหา mouComp ไม่เจอ (undefined) จึงต้อง guard ทุกจุดที่อ้างถึง
        const selectedCompId = currentStatus.selectedOption?.compId?.toLowerCase();
        const mouCompanies =
          this.complaintData?.fastTrackAllowance?.mouCompanies || [];
        // COMPLAINT-1534 ถ้าหาบริษัทที่เลือกไม่เจอ (เจ้าหน้าที่เปลี่ยนผู้ประกอบการ) ให้ใช้ข้อมูลคำสั่งซื้อเดิมที่ผู้ร้องแจ้งไว้
        var mouComp =
          mouCompanies.find(function(mou) {
            return mou?.companyId?.toLowerCase() === selectedCompId;
          }) || mouCompanies[0];
        const isFallbackMou =
          !!mouComp && mouComp.companyId?.toLowerCase() !== selectedCompId;
        const fallbackMouNote = isFallbackMou
          ? ` <small class="text-muted">(ข้อมูลที่ผู้ร้องแจ้งกับ ${mouComp.companyName})</small>`
          : "";
        if (mouComp) {
          fileNames = mouComp.attachFiles?.map((f) => f.fileName).join(",");
        }

        const complainants = this.personals
          ?.map((f) => `${f.fullname}`)
          .join(",");

        const complainantTels = this.personals
          ?.map((f) => `${f.tel}`)
          .join(",");

        const complainantAddresses = this.personals
          ?.map(
            (f) =>
              `${f.address1} ${f.tumbon} ${f.ampher} ${f.province} ${f.zipcode}`,
          )
          .join(",");

        const granters = this.attorneys //ผู้มอบ
          ?.map((f) => `${f.fullname}`)
          .join(",");

        // check box เลือกข้อมูลที่ต้องการเปิดเผย หรือ ส่งไปยัง fasttrack
        // complainants ? "checked" : "disabled"
        // granters ? "checked" : "disabled"
        // mouComp?.purchaseNo ? "checked" : "disabled"
        // fileNames ? "checked" : "disabled"
        html = `<div style="display:grid;grid-template-columns:200px minmax(0,1fr);gap:6px;text-align:left;word-break:break-word;overflow-wrap:break-word;">
    <div><label>ชื่อผู้ประกอบการ</label></div>
    <div>${currentStatus.selectedOption.text}</div>

    <div><label><input type="checkbox" id="chk_complainants" data-text="complainer" ${
      true ? "checked" : "disabled"
    } /> ผู้ร้องทุกข์/ผู้ดำเนินการ</label></div>
    <div>${true ? complainants : "-"}</div>

    <div><label><input type="checkbox" id="chk_granters" data-text="granter" ${
      true ? "checked" : "disabled"
    } /> ผู้มอบอำนาจ</label></div>
    <div>${true ? granters : "-"}</div>

    <div><label><input type="checkbox" id="chk_address" data-text="address" ${
      complainantAddresses ? "" : "disabled"
    } /> ที่อยู่</label></div>
    <div>${complainantAddresses ? complainantAddresses : "-"}</div>

    <div><label><input type="checkbox" id="chk_tel" data-text="tel" ${
      complainantTels ? "" : "disabled"
    } /> หมายเลขโทรศัพท์</label></div>
    <div>${complainantTels ? complainantTels : "-"}</div>

    <div><label><input type="checkbox" id="chk_purchaseNo" data-text="purchaseNo" ${
      mouComp?.purchaseNo ? "checked" : "disabled"
    } /> หมายเลขคำสั่งซื้อ</label></div>
    <div>${
      mouComp?.purchaseNo ? mouComp.purchaseNo + fallbackMouNote : "-"
    }</div>

    <div><label><input type="checkbox" id="chk_files" data-text="purchaseFiles" ${
      fileNames ? "checked" : "disabled"
    } /> ไฟล์แนบรายละเอียดคำสั่งซื้อ</label></div>
    <div>${fileNames ? fileNames + fallbackMouNote : "-"}</div>
    
  </div>`;
        _this.selectedSwalItems = [];
      }

      this.$swal({
        title: "ยืนยันการบันทึกข้อมูล?",
        html: html,
        icon: "success",
        showCancelButton: true,
        confirmButtonText: "บันทึก",
        cancelButtonText: "ยกเลิก",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-primary ml-1",
        },
        buttonsStyling: false,
        // attach listeners when swal opens, update component array on check/uncheck
        willOpen: () => {
          try {
            if (
              !(
                currentStatus.statusID === 514 || currentStatus.statusID === 518
              )
            ) {
              return;
            }
            const checkboxIds = [
              "chk_complainants",
              "chk_granters",
              "chk_address",
              "chk_tel",
              "chk_purchaseNo",
              "chk_files",
            ];

            // reset and initialize from default checked states
            _this.selectedSwalItems = [];

            // check box เลือกข้อมูลที่ต้องการเปิดเผย หรือ ส่งไปยัง fasttrack
            checkboxIds.forEach((id) => {
              const el = document.getElementById(id);
              if (el) {
                // clear previous handler (safe) and add new one
                el.onchange = null;
                const handler = function(e) {
                  const txt = e.target.dataset.text;
                  if (e.target.checked) {
                    if (!_this.selectedSwalItems.includes(txt)) {
                      _this.selectedSwalItems.push(txt);
                    }
                  } else {
                    _this.selectedSwalItems = _this.selectedSwalItems.filter(
                      (x) => x !== txt,
                    );
                  }
                };
                el.addEventListener("change", handler, false);

                // pick up initial checked state
                if (el.checked) {
                  const txt = el.dataset.text;
                  if (!_this.selectedSwalItems.includes(txt)) {
                    _this.selectedSwalItems.push(txt);
                  }
                }
              }
            });
          } catch (ex) {
            // ignore
          }
        },

        // return checked items so result.value contains them after confirm
        preConfirm: () => {
          if (
            !(currentStatus.statusID === 514 || currentStatus.statusID === 518)
          ) {
            return;
          }
          return { checkedItems: _this.selectedSwalItems.slice() };
        },
      }).then((result) => {
        if (result.value) {
          //this.$emit("handle-submit", this.selected, this.selectSend);
          // //console.log"this", this.bTabs);
          // //console.log"selectedTab", this.selectedTab);

          // capture checked items from swal (or fallback to stored array)
          const checkedItems =
            (result.value && result.value.checkedItems) ||
            _this.selectedSwalItems ||
            [];
          console.log("checkedItems", checkedItems);

          let commonId = null;
          let commonIds = [];
          let provinceCode = null;
          let districtCode = null;
          let submitStatus = currentStatus.statusID;
          let subCommonId = null;
          let additionalDatum = [];

          if (currentStatus.statusID === 10 || currentStatus.statusID === 80) {
            // province
            provinceCode = currentStatus.selectedOption.value;
          } else if (currentStatus.statusID === 17) {
            commonId = currentStatus.selectedOption.value;
          } else if (currentStatus.statusID === 999) {
            commonId = currentStatus.departmentID;
          } else if (
            currentStatus.statusID >= 5000 &&
            currentStatus.statusID < 6000
          ) {
            // ส่งต่อเจ้าหน้าที่โดย AI
            submitStatus = 17;
            commonId = currentStatus.commonID;
          } else if (currentStatus.statusID === 121) {
            submitStatus = currentStatus.selectedOption.value;
          } else if (
            currentStatus.statusID === 11 ||
            currentStatus.statusID === 31 ||
            currentStatus.statusID === 504 ||
            currentStatus.statusID === 81
          ) {
            // ส่งต่อหลายหน่วยงาน
            if (!Array.isArray(currentStatus.selectedOption)) {
              commonIds.push(currentStatus.selectedOption?.value);
            } else {
              currentStatus.selectedOption?.forEach(function(s) {
                if (s) {
                  commonIds.push(s.value);
                  if (s.provincialLevel > 0) {
                    if (_this.extendProvinceSelected) {
                      provinceCode = _this.extendProvinceSelected.value;
                    }
                  }
                  if (s.provincialLevel > 1) {
                    if (_this.extendDistrictSelected) {
                      districtCode = _this.extendDistrictSelected.value;
                    }
                  }
                }
              });
            }
            commonId = commonIds[0];
          } else if (
            currentStatus.statusID === 514 ||
            currentStatus.statusID === 518
          ) {
            if (currentStatus.selectedOption.refCompid) {
              // ถ้ามี refCompid หมายความว่าเป็นบริษัทลูก โดย refCompid คือ CompanyId แม่
              commonId = currentStatus.selectedOption.refCompid; // CompanyId แม่
              commonIds.push(currentStatus.selectedOption.compId); // CompanyId ลูก
            } else {
              commonId = currentStatus.selectedOption.compId; // CompanyId แม่
            }
            subCommonId =
              currentStatus.statusID === 514
                ? currentStatus.selectedOption2?.value
                : null; // ส่งหน่วยงานภายใน
            additionalDatum = checkedItems; //ข้อมูลที่ต้องการเปิดเผยไปยัง fasttrack
          } else if (currentStatus.statusID === 510) {
            /// กทม ส่งต่อเขต/อำเภอ
            districtCode = currentStatus.selectedOption.value;
          } else {
            commonId = currentStatus.selectedOption?.value;
          }
          console.log(
            "_this.extendProvinceSelected",
            this.extendProvinceSelected,
          );

          // เช็คว่าตัว extend มี provincialLevel เท่าไหร่
          //ถ้าเป็น array
          if (Array.isArray(currentStatus.selectedOption)) {
            if (Array.isArray(currentStatus.selectedOption)) {
              // console.log('หน่วยงานภายนอกหลายหน่วยงาน');
              if (currentStatus.selectedOption) {
                currentStatus.selectedOption?.forEach(function(s, i) {
                  if (currentStatus.selectedOption[i].provincialLevel > 0) {
                    // 1 เก็บจังหวัดเพิ่ม
                    if (_this.extendProvinceSelected) {
                      provinceCode = _this.extendProvinceSelected.value;
                    }
                  }
                  if (currentStatus.selectedOption[i].provincialLevel > 1) {
                    // 2 เก็บอำเภอเพิ่ม
                    if (_this.extendDistrictSelected) {
                      districtCode = _this.extendDistrictSelected.value;
                    }
                  }
                });
              }
              //ถ้าเป็น object
            } else {
              if (currentStatus.selectedOption) {
                // console.log('หน่วยงานภายนอก 1 หน่วยงาน เเละหลายหน่วยงานภายใน');
                if (currentStatus.selectedOption.provincialLevel > 0) {
                  // 1 เก็บจังหวัดเพิ่ม
                  if (_this.extendProvinceSelected) {
                    provinceCode = _this.extendProvinceSelected.value;
                  }
                }
                if (currentStatus.selectedOption.provincialLevel > 1) {
                  // 2 เก็บอำเภอเพิ่ม
                  if (_this.extendDistrictSelected) {
                    districtCode = _this.extendDistrictSelected.value;
                  }
                }
              }
            }
          }

          let redirectUrl =
            location.origin +
            this.$router.resolve({
              name: this.redirectComponentName,
              query: {
                backComponentName: this.backComponentName,
                message: "",
                //isGroupGuid: true,
              },
            }).href;
          let redirectBack =
            location.origin +
            this.$router.resolve({ name: this.$route.name }).href;

          if (this.$route.query.id !== null) {
            redirectBack += "?id=" + this.$route.query.id;
          }

          const fileIds = this.filterAttachFile(4).map((element) => {
            return element.fileUploadId;
          });

          const additionalFileIds = this.additionalFilesForDisplay.map(
            (element) => {
              return element.fileUploadId;
            },
          );

          let updateData = null;
          if (this.isClue === false) {
            updateData = {
              //complaintId: "7D85EDF2-F181-482D-8D61-48F6BE89925A",
              //userId: "250C39C7-64AE-44ED-A72F-08D9BE13C7C5",
              destination: this.destination,
              complaintId: this.complaintId,
              userId: userData.userId(),
              departmentID: userData.departmentId(),
              statusId: submitStatus,
              comment: this.comment,
              fileId: fileIds,
              additionalFileIds: additionalFileIds,
              redirectUrl,
              redirectBack,
              commonId,
              commonIds,
              provinceCode,
              districtCode,
              subCommonId,
              additionalDatum,
            };
          } else {
            // แจ้งแบาะแส
            let newDepartmentId = null;
            if (submitStatus === 9) {
              newDepartmentId =
                commonId === null || commonId === undefined
                  ? userData.departmentId()
                  : commonId;
            } else if (submitStatus === 18) {
              newDepartmentId = appsettings.clueDepartmentID.screening;
            } else if (submitStatus === 124) {
              newDepartmentId = userData.departmentId();
            } else if (submitStatus === 11 || submitStatus === 31) {
              commonIds =
                commonIds.length <= 0 ? [userData.departmentId()] : commonIds;
            }
            //console.log"newDepartmentId", newDepartmentId);
            updateData = {
              destination: this.destination,
              clueId: this.clueId,
              userId: userData.userId(),
              departmentID: userData.departmentId(),
              statusId: submitStatus,
              comment: this.comment,
              fileId: fileIds,
              additionalFileIds: additionalFileIds,
              redirectUrl,
              redirectBack,
              commonId: newDepartmentId, // หน่วยงานที่เลือก Dropdown
              commonIds: commonIds, // หน่วยงานที่เลือก หลายหน่วยงาน
              provinceCode,
              districtCode,
            };
          }

          // const data = {
          //   //complaintId: "7D85EDF2-F181-482D-8D61-48F6BE89925A",
          //   //userId: "250C39C7-64AE-44ED-A72F-08D9BE13C7C5",
          //   destination: this.destination,
          //   complaintId: this.complaintId,
          //   userId: userData.userId(),
          //   departmentID: userData.departmentId(),
          //   statusId: submitStatus,
          //   comment: this.comment,
          //   fileId: fileIds,
          //   additionalFileIds: additionalFileIds,
          //   redirectUrl,
          //   redirectBack,
          //   commonId,
          //   provinceCode,
          // };

          if (
            this.isComplaintGrp === true &&
            (this.copyComponentName === "ScreeningGroupManage" ||
              this.copyComponentName == "OfficerGroupManage" ||
              this.copyComponentName == "LawOfficerGroupManage")
          ) {
            // ปรับให้เข้ากับ model
            updateData.complaintGroupId = this.complaintId;
            updateData.complaintId = "00000000-0000-0000-0000-000000000000";
            // //console.log"storeComplaintGroup - updateComplaintProcess", updateData);
          }

          //console.log"onSubmitBtnCliked", updateData);
          if (
            this.copyComponentName == "ScreeningGroupManage" ||
            this.copyComponentName == "OfficerGroupManage" ||
            this.copyComponentName == "LawOfficerGroupManage"
          ) {
            _this.showOverlay = true;

            storeComplaintGroup
              .updateComplaintProcess(updateData)
              .then(function(response) {
                // handle success
                //console.log"data", response);

                if (
                  response.data.success === false ||
                  response.data.data.status === false
                ) {
                  _this.$bvToast.toast("เกิดข้อผิดพลาด", {
                    title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
                    variant: "danger",
                    solid: false,
                  });
                } else if (
                  response.data.data.urlRedirect != null &&
                  response.data.data.urlRedirect !== undefined
                ) {
                  _this.$bvToast.toast("บันทึกข้อมูลสำเร็จ", {
                    title: `ระบบได้บันทึกการแก้ไขของท่านแล้ว`,
                    variant: "success",
                    solid: false,
                  });
                  window.location.href = response.data.data.urlRedirect;
                } else {
                  _this.$bvToast.toast("บันทึกข้อมูลสำเร็จ", {
                    title: `ระบบได้บันทึกการแก้ไขของท่านแล้ว`,
                    variant: "success",
                    solid: false,
                  });
                  window.open(
                    _this.$router.resolve({
                      name: _this.redirectComponentName,
                      query: {
                        backComponentName: _this.backComponentName,
                        message: response.data.data.msg,
                        //isGroupGuid: true,
                      },
                    }).href,
                    "_self",
                  );
                }
              })
              .catch(function(error) {
                // handle error
                //console.log"error", error);
              })
              .then(function() {
                _this.showOverlay = false;
              });
          } else if (this.copyComponentName == "ClueActionManage") {
            _this.showOverlay = true;

            storeClue
              .updateProcess(updateData)
              .then(function(response) {
                // handle success
                //console.log"data", response);

                if (
                  response.data.success === false ||
                  response.data.data.status === false
                ) {
                  _this.$bvToast.toast("เกิดข้อผิดพลาด", {
                    title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
                    variant: "danger",
                    solid: false,
                  });
                } else if (
                  response.data.data.urlRedirect != null &&
                  response.data.data.urlRedirect !== undefined
                ) {
                  _this.$bvToast.toast("บันทึกข้อมูลสำเร็จ", {
                    title: `ระบบได้บันทึกการแก้ไขของท่านแล้ว`,
                    variant: "success",
                    solid: false,
                  });
                  window.location.href = response.data.data.urlRedirect;
                } else {
                  _this.$bvToast.toast("บันทึกข้อมูลสำเร็จ", {
                    title: `ระบบได้บันทึกการแก้ไขของท่านแล้ว`,
                    variant: "success",
                    solid: false,
                  });
                  window.open(
                    _this.$router.resolve({
                      name: _this.redirectComponentName,
                      query: {
                        backComponentName: _this.backComponentName,
                        message: response.data.data.msg,
                        //isGroupGuid: true,
                      },
                    }).href,
                    "_self",
                  );
                }
              })
              .catch(function(error) {
                // handle error
                //console.log"error", error);
              })
              .then(function() {
                _this.showOverlay = false;
              });
          } else {
            //mange ปกติ

            _this.showOverlay = true;

            var _title = "กำลังดำเนินการ";
            var _text =
              "กรุณารอสักครู่และโปรดอย่าปิดหรือรีโหลดหน้า website นี้ ขณะกำลังดำนเนิาการ . . .";

            const vm = this;
            if (submitStatus === 605) {
              _title = "กำลังส่งเรื่องไปยังระบบเฝ้าระวังฯ (OCPB Care)";
              _text =
                "กรุณารอสักครู่และโปรดอย่าปิดหรือรีโหลดหน้า website นี้ ขณะกำลังส่งเรื่อง . . .";

              // Swal ที่ 2 : Loading (lock screen)
              vm.$swal({
                title: _title,
                text: _text,
                allowOutsideClick: false,
                allowEscapeKey: false,
                showConfirmButton: false,
                didOpen: () => {
                  vm.$swal.showLoading();
                },
              });
            }
            storeComplaint
              .updateComplaintProcess(updateData)
              .then(function(response) {
                // handle success
                //console.log"data", response);

                // console.log("data", response);
                if (submitStatus === 605) {
                  // ปิด loading
                  vm.$swal.close();
                }

                if (
                  response.data.success === false ||
                  response.data.data.status === false
                ) {
                  console.log("1");

                  /* เช็คกรณีเปิด 2 เเท็บเเล้วกดส่งต่อพร้อมกันตอนบันทึกสถานะส่งต่อหน่วยงานภายใน */
                  if (currentStatus.statusID === 9) {
                    console.log("1.1");
                    _this.$swal({
                      // title: "เกิดข้อผิดพลาดในการบันทึกข้อมูล",
                      text: response.data.message,
                      icon: "error",
                      showCancelButton: true,
                      showConfirmButton: false,
                      //confirmButtonText: "ใช่, ยืนยัน",
                      cancelButtonText: "ปิด",
                      //reverseButtons: true,
                      customClass: {
                        confirmButton: "btn btn-primary",
                        cancelButton: "btn btn-danger ml-1",
                      },
                      buttonsStyling: false,
                      onClose: () => {
                        return;
                      },
                    });
                  } else {
                    console.log("1.2");
                    _this.$bvToast.toast("เกิดข้อผิดพลาด", {
                      title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
                      variant: "danger",
                      solid: false,
                    });
                  }
                } else if (
                  // case เอกสาร
                  response.data.data.urlRedirect != null &&
                  response.data.data.urlRedirect !== undefined
                ) {
                  console.log("2");
                  _this.$bvToast.toast("บันทึกข้อมูลสำเร็จ", {
                    title: `ระบบได้บันทึกการแก้ไขของท่านแล้ว`,
                    variant: "success",
                    solid: false,
                  });
                  window.location.href = response.data.data.urlRedirect;
                } else {
                  // case บันทึกสถานะเฉย ๆ

                  console.log("3");
                  // กรณีส่งเรื่องไป OCPB Care สำเร็จ
                  if (submitStatus === 605) {
                    _this.$bvToast.toast("บันทึกข้อมูลสำเร็จ", {
                      title: `ระบบได้บันทึกการแก้ไขของท่านแล้ว`,
                      variant: "success",
                      solid: false,
                    });
                    _this
                      .$swal({
                        icon: "success",
                        title: "ส่งเรื่องไปยังระบบ OCPB Care สำเร็จ",
                        text: "ระบบได้บันทึกข้อมูลของท่านแล้ว",
                        showConfirmButton: false,
                        timer: 1000,
                      })
                      .then((result) => {
                        window.open(
                          _this.$router.resolve({
                            name: _this.redirectComponentName,
                            query: {
                              backComponentName: _this.backComponentName,
                              message: response.data.data.msg,
                            },
                          }).href,
                          "_self",
                        );
                      });
                    // _this
                    //   .$swal({
                    //     customClass: {
                    //       confirmButton: "btn btn-success",
                    //     },
                    //     icon: "success",
                    //     title: `ส่งเรื่องไปยังระบบ OCPB Care สำเร็จ`,
                    //     text: "ระบบได้บันทึกข้อมูลของท่านแล้ว",
                    //     confirmButtonText: "ตกลง",
                    //     allowOutsideClick: false,
                    //     allowEscapeKey: false,
                    //   })
                    //   .then(() => {
                    //     // 🔁 Redirect หลัง user กดปุ่ม
                    //     // case บันทึกสถานะเฉย ๆ
                    //     _this.$bvToast.toast("บันทึกข้อมูลสำเร็จ", {
                    //       title: `ระบบได้บันทึกการแก้ไขของท่านแล้ว`,
                    //       variant: "success",
                    //       solid: false,
                    //     });

                    //     _this.$swal({
                    //       icon: "success",
                    //       title: "ดำเนินการสำเร็จ",
                    //       showConfirmButton: false,
                    //       timer: 1000,
                    //     }).then((result) => {
                    //       window.open(
                    //         _this.$router.resolve({
                    //           name: _this.redirectComponentName,
                    //           query: {
                    //             backComponentName: _this.backComponentName,
                    //             message: response.data.data.msg,
                    //           },
                    //         }).href,
                    //         "_self"
                    //       );
                    //     });

                    //   });
                  } else {
                    // case บันทึกสถานะเฉย ๆ
                    _this.$bvToast.toast("บันทึกข้อมูลสำเร็จ", {
                      title: `ระบบได้บันทึกการแก้ไขของท่านแล้ว`,
                      variant: "success",
                      solid: false,
                    });
                    window.open(
                      _this.$router.resolve({
                        name: _this.redirectComponentName,
                        query: {
                          backComponentName: _this.backComponentName,
                          message: response.data.data.msg,
                        },
                      }).href,
                      "_self",
                    );
                  }
                }
              })
              .catch(function(error) {
                console.log("4");
                // handle error
                console.log("error", error);

                // ปิด loading
                vm.$swal.close();
                vm.$swal({
                  icon: "error",
                  title: _title + " ไม่สำเร็จ กรุณาลองใหม่อีกครั้ง",
                  text: "เกิดข้อผิดพลาดในการบันทึกข้อมูล",
                  confirmButtonText: "ปิด",
                });
              })
              .then(function() {
                console.log("5");
                _this.showOverlay = false;
              });
          }
        }
      });
    },
    onSubmitBtnCliked_Tab3() {
      const _this = this;

      if (_this.statusProcess === null || _this.statusProcess === undefined) {
        _this.$bvToast.toast("กรุณาเลือกสถานะการดำเนินการ", {
          title: `กรุณาเลือกสถานะการดำเนินการ`,
          variant: "danger",
          solid: false,
        });

        return;
      }

      // COMPLAINT-818 เช็คเพิ่มเติมว่ามี showOption ไหม ถ้ามีจะต้องเช็คด้วยว่ามีค่าไหม
      if (_this.statusProcess.showOption === true) {
        if (
          !(
            _this.extendStatusProcess !== null &&
            _this.extendStatusProcess.value != null
          )
        ) {
          _this.$bvToast.toast("กรุณากรอกข้อมูลให้ครบถ้วน", {
            title: `กรุณากรอกข้อมูลให้ครบถ้วน`,
            variant: "danger",
            solid: false,
          });

          return;
        }
      }

      // เช็ค กรณีจังหวัด
      if (_this.statusProcess)
        if (_this.extendStatusProcess) {
          // เช็คว่าตัว extend มี provincialLevel เท่าไหร่
          if (_this.extendStatusProcess.provincialLevel > 0) {
            // 1 จังหวัด
            if (_this.extendProvinceSelected) {
              const pCode = _this.extendProvinceSelected.value;
              if (!pCode) {
                // validate required จังหวัด
                _this.$bvToast.toast("กรุณาเลือกจังหวัดที่จะส่งต่อ", {
                  title: `เกิดข้อผิดพลาด`,
                  variant: "danger",
                  solid: false,
                });
                return;
              }
            } else {
              _this.$bvToast.toast("กรุณาเลือกจังหวัดที่จะส่งต่อ", {
                title: `เกิดข้อผิดพลาด`,
                variant: "danger",
                solid: false,
              });
              return;
            }
          }
          if (_this.extendStatusProcess.provincialLevel > 1) {
            // 2 อำเภอ
            if (_this.extendDistrictSelected) {
              const dCode = _this.extendDistrictSelected.value;
            }
          }
        }

      this.$swal({
        title: "ยืนยันการบันทึกข้อมูล?",
        text: "",
        icon: "success",
        showCancelButton: true,
        confirmButtonText: "บันทึก",
        cancelButtonText: "ยกเลิก",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-primary ml-1",
        },
        buttonsStyling: false,
      })
        .then((result) => {
          //console.log".then", result);
          if (result.value) {
            let commonId = null;
            let provinceCode = null;
            let districtCode = null;

            if (_this.statusProcess.statusId === 10) {
              // province
              provinceCode = _this.extendStatusProcess.value;
            } else {
              commonId = _this.extendStatusProcess?.value;
            }

            // เช็คว่าตัว extend มี provincialLevel เท่าไหร่
            if (_this.extendStatusProcess) {
              if (_this.extendStatusProcess.provincialLevel > 0) {
                // 1 เก็บจังหวัดเพิ่ม
                if (_this.extendProvinceSelected) {
                  provinceCode = _this.extendProvinceSelected.value;
                }
              }
              if (_this.extendStatusProcess.provincialLevel > 1) {
                // 2 เก็บอำเภอเพิ่ม
                if (_this.extendDistrictSelected) {
                  districtCode = _this.extendDistrictSelected.value;
                }
              }
            }

            //console.log"provinceCode", provinceCode);
            //console.log"commonId", commonId);

            const fileIds = this.filterAttachFile(3).map((element) => {
              return element.fileUploadId;
            });

            const fileIds2 = this.filterAttachFile(4).map((element) => {
              return element.fileUploadId;
            });

            //console.log"fileIds", fileIds);
            //console.log"fileIds2", fileIds2);

            fileIds.push(...fileIds2);

            const data = {
              //complaintId: "7D85EDF2-F181-482D-8D61-48F6BE89925A",
              //userId: "250C39C7-64AE-44ED-A72F-08D9BE13C7C5",
              destination: this.destination,
              complaintId: this.complaintId,
              userId: userData.userId(),
              departmentID: userData.departmentId(),
              statusId: this.statusProcess.statusId,
              comment: this.comment,
              fileId: fileIds,
              commonId,
              provinceCode,
              districtCode,
            };

            //console.log"data", data);

            _this.showOverlay = true;

            if (
              this.isComplaintGrp === true &&
              (this.copyComponentName === "ScreeningGroupManage" ||
                this.copyComponentName === "OfficerGroupManage" ||
                this.copyComponentName === "LawOfficerGroupManage")
            ) {
              // ปรับให้เข้ากับ model
              data.complaintGroupId = this.complaintId;
              data.complaintId = "00000000-0000-0000-0000-000000000000";
              //console.log"storeComplaintGroup - updateComplaintProcess", data);

              storeComplaintGroup
                .updateComplaintProcess_No_Doc(data)
                .then(function(response) {
                  // handle success
                  //console.log"data", response);

                  if (
                    response.data.success === false ||
                    response.data.data.status === false
                  ) {
                    _this.$bvToast.toast("เกิดข้อผิดพลาด", {
                      title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
                      variant: "danger",
                      solid: false,
                    });
                  } else {
                    _this.$bvToast.toast("บันทึกข้อมูลสำเร็จ", {
                      title: `ระบบได้บันทึกการแก้ไขของท่านแล้ว`,
                      variant: "success",
                      solid: false,
                    });
                    window.open(
                      _this.$router.resolve({
                        name: _this.backComponentName,
                      }).href,
                      "_self",
                    );
                  }
                })
                .catch(function(error) {
                  // handle error
                  //console.log"error", error);
                })
                .then(function() {
                  _this.showOverlay = false;
                });
            } else {
              storeComplaint
                .updateComplaintProcessNoDoc(data)
                .then(function(response) {
                  // handle success
                  //console.log"data", response);

                  if (
                    response.data.success === false ||
                    response.data.data.status === false
                  ) {
                    //เช็คกรณีเปิด 2 เเท็บเเล้วกดส่งต่อพร้อมกันตอนบันทึกสถานะส่งต่อหน่วยงานภายใน
                    if (_this.statusProcess.statusId === 9) {
                      _this.$swal({
                        title: "เกิดข้อผิดพลาดในการบันทึกข้อมูล",
                        text: response.data.message,
                        icon: "error",
                        //showCancelButton: true,
                        //confirmButtonText: "ใช่, ยืนยัน",
                        //cancelButtonText: "ไม่, ยกเลิก",
                        //reverseButtons: true,
                        customClass: {
                          confirmButton: "btn btn-primary",
                          cancelButton: "btn btn-outline-primary ml-1",
                        },
                        buttonsStyling: false,
                        onClose: () => {
                          return;
                        },
                      });
                    } else {
                      _this.$bvToast.toast("เกิดข้อผิดพลาด", {
                        title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
                        variant: "danger",
                        solid: false,
                      });
                    }
                  } else {
                    _this.$bvToast.toast("บันทึกข้อมูลสำเร็จ", {
                      title: `ระบบได้บันทึกการแก้ไขของท่านแล้ว`,
                      variant: "success",
                      solid: false,
                    });
                    window.open(
                      _this.$router.resolve({
                        name: _this.backComponentName,
                      }).href,
                      "_self",
                    );
                  }
                })
                .catch(function(error) {
                  // handle error
                  //console.log"error", error);
                })
                .then(function() {
                  _this.showOverlay = false;
                });
            }
            // storeComplaint
            // .updateComplaintProcessNoDoc(data)
            // .then(function(response) {
            //   // handle success
            //   //console.log"data", response);

            //   if (
            //     response.data.success === false ||
            //     response.data.data.status === false
            //   ) {
            //     _this.$bvToast.toast("เกิดข้อผิดพลาด", {
            //       title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
            //       variant: "danger",
            //       solid: false,
            //     });
            //   } else {
            //     _this.$bvToast.toast("บันทึกข้อมูลสำเร็จ", {
            //       title: `ระบบได้บันทึกการแก้ไขของท่านแล้ว`,
            //       variant: "success",
            //       solid: false,
            //     });
            //     window.open(
            //       _this.$router.resolve({
            //         name: _this.backComponentName,
            //       }).href,
            //       "_self"
            //     );
            //   }
            // })
            // .catch(function(error) {
            //   // handle error
            //   //console.log"error", error);
            // })
            // .then(function() {
            //   _this.showOverlay = false;
            // });
          }
        })
        .catch(function(error) {
          // handle error
          //console.log"error", error);
        });
    },
    onBackBtnClicked() {
      const routeData = this.$router.resolve({ name: this.backComponentName });
      window.open(routeData.href, "_self");
    },
    onSubTabClicked(id) {
      /* ถ้าเป็น statusid = 27 ให้เพิ่ม default comment */
      const Setcomment27 = this.comment27;
      var SetCommentcommon = this.comment;
      this.bTabs.find(function(value) {
        if (value.tab.id === id) {
          if (value.selectedStatus === 27) {
            SetCommentcommon = Setcomment27;
          } else {
            SetCommentcommon = "";
          }
          value.selectedStatus = null;
        }
      });

      this.bTabs.forEach(function(res, index) {
        // console.log("res", res);
        res.statusModel.forEach(function(res2, index2) {
          res2.showOption = false;
          res2.showOption2 = false;
        });
      });

      this.comment = SetCommentcommon;
      this.tabIndexdetail = id;
      this.selectedTab = id;
    },
    onUploadFileChanged(e) {
      // อัพโหลดหลายไฟล์ได้พร้อมกัน
      const selectedFiles = e.target.files;
      if (
        selectedFiles === null ||
        selectedFiles === undefined ||
        selectedFiles.length <= 0
      ) {
        return;
      }

      const _this = this;

      var isMissing = this.onValidateExtensionFiles(selectedFiles, null);
      if (isMissing === true) {
        return;
      }

      selectedFiles.forEach(function(value, index) {
        //console.log"value", value);
        // console.log("righttabaction.onuploadfilechanged.value", value);
        _this.createBase64Image(value, null);
      });
    },
    onUploadFileChangedType3(e) {
      // อัพโหลดหลายไฟล์ได้พร้อมกัน
      const selectedFiles = e.target.files;
      if (
        selectedFiles === null ||
        selectedFiles === undefined ||
        selectedFiles.length <= 0
      ) {
        return;
      }

      const _this = this;
      this.file1Overlay = true;

      var isMissing = this.onValidateExtensionFiles(selectedFiles, 3);

      if (isMissing === true) {
        this.file1Overlay = false;
        return;
      }

      selectedFiles.forEach(function(value, index) {
        //console.log"value", value);
        // console.log("righttabaction.onuploadfilechangedtype3.value", value);
        _this.createBase64Image(value, 3);
      });
    },
    onUploadFileChangedType4(e) {
      // อัพโหลดหลายไฟล์ได้พร้อมกัน
      const selectedFiles = e.target.files;
      if (
        selectedFiles === null ||
        selectedFiles === undefined ||
        selectedFiles.length <= 0
      ) {
        return;
      }

      const _this = this;
      this.file2Overlay = true;

      var isMissing = this.onValidateExtensionFiles(selectedFiles, 4);
      if (isMissing === true) {
        this.file2Overlay = false;
        return;
      }

      selectedFiles.forEach(function(value, index) {
        //console.log"value", value);
        // console.log("righttabaction.onuploadfilechangedtype4.value", value);
        _this.createBase64Image(value, 4);
      });
    },
    createBase64Image(fileObject, type = null) {
      const _this = this;
      const reader = new FileReader();

      const fileName = fileObject.name;
      const fileSize = fileObject.size;

      reader.onload = (e) => {
        const fileBase64 = e.target.result;
        //console.log
        //   "fileName=",
        //   fileName,
        //   "fileSize=",
        //   fileSize,
        //   "fileType=",
        //   _this.selected,
        //   "Type=",
        //   type
        // );

        try {
          this.$refs["file-input"].reset();
          this.$refs["file-input2"].reset();
        } catch (ex) {
          //console.logex);
        }

        const data = [
          {
            fileName: fileName,
            fileSize: fileSize,
            fileBase64: fileBase64,
            //keyId: this.complaintId,
            userId: userData.userId(),
            TypeUserUpload: type,
          },
        ];
        if (type == null) {
          storeFileUpload
            .uploadFile(data)
            .then(function(response) {
              // handle success
              //console.logresponse);
              // console.log(response);
              response.data.data.forEach(function(value, index) {
                ////console.log'emit upload', value)
                //this.$emit('handleSend', id)
                _this.emitUploadFile(value);
              });
            })
            .catch(function(error) {
              // handle error
              //console.log"error", error);
            })
            .then(function() {
              // always executed
              _this.file2Overlay = false;
            });
        } else {
          storeFileUpload
            .uploadFileWithType(data)
            .then(function(response) {
              // handle success
              //console.logresponse);
              // console.log(response);
              response.data.data.forEach(function(value, index) {
                ////console.log'emit upload', value)
                //this.$emit('handleSend', id)
                _this.emitUploadFile(value);
              });
            })
            .catch(function(error) {
              // handle error
              //console.log"error", error);
            })
            .then(function() {
              // always executed
              if (type === 3) {
                _this.file1Overlay = false;
              } else {
                _this.file2Overlay = false;
              }
            });
        }

        ////console.log'base64', base64)
      };

      reader.readAsDataURL(fileObject);
    },
    emitUploadFile(file) {
      this.attachFiles.push(file);
    },
    onAttachFileDelete(id) {
      const file = this.attachFiles.find(function(value) {
        return value.attachId === id;
      });

      var filteredAry = this.attachFiles.filter((o) => o.attachId != id);

      this.attachFiles = filteredAry;
    },
    // หาหน่วยงานที่ผู้ใช้สังกัด จาก options ของ dropdown
    // ใช้เทียบแบบ case-insensitive เพราะ GUID จาก API กับ localStorage ตัวพิมพ์ไม่ตรงกันได้
    findOwnDepartmentOption(options) {
      const ownId = userData.departmentId();

      if (!ownId || !Array.isArray(options)) return null;

      const found = options.find(
        (s) => s.value && s.value.toLowerCase() === ownId.toLowerCase()
      );

      return found == null ? null : found;
    },
    onStatusChange(statusId, tabId) {
      // console.log("change111:", statusId, " ", tabId);

      const _this = this;
      const _tab = tabId;
      console.log(_tab);
      this.bTabs.forEach(function(value, index) {
        value.statusModel.forEach(function(value2, index2) {
          value2.showOption = false;
          value2.showOption2 = false;
        });
      });

      // //console.log'userId', userData.userId())
      // //console.log'username', userData.username())
      // //console.log'fullName', userData.fullName())

      const currentTab = this.bTabs.find(function(value) {
        return value.tab.id === tabId;
      });

      let currentStatus = currentTab.statusModel.find(function(value) {
        return value.statusID === statusId;
      });

      //console.log"currentStatus.statusID:", currentStatus.statusID);

      // if (currentStatus.statusID === 9 || currentStatus.statusID === 605) {
      if (currentStatus.statusID === 9) {
        // หน่วยงานภายใน
        storeMaster
          .getDepartment(2)
          .then(function(response) {
            // handle success
            // console.log("response", response);
              currentStatus.selectOptions = response.data.data.filter(
                (s) =>
                  s.value !== userData.departmentId() &&
                  s.value !== "535e93cc-ad5a-488f-c410-08d86b48aba4",
              );

            // กรณีสิทธิ์เป็น `เจ้าหน้าที่`, `คัดกรอง` และ ธุรการกอง จะต้องไม่แสดง `กองกฏหมาย-บังคับคดี`
            const officerRole = userData.selectedUserRole().value.toUpperCase();
            if (
              officerRole === "5B70388F-7208-4F0A-BF76-F4D7DE349E92" || // เจ้าหน้าที่
              officerRole === "11857BDF-5691-45F1-823E-F5C3A6FD9FF4" || // คัดกรอง
              officerRole === "6F1AACD6-2EBA-4FB7-ABA2-02569990E5F4" // ธุรการกอง
            ) {
              currentStatus.selectOptions = currentStatus.selectOptions.filter(
                (s) =>
                  s.value.toUpperCase() !==
                    "A74DBA00-A697-4906-9125-260C8955275D" &&
                  s.value.toUpperCase() !==
                    "0351CA3F-4D3C-4FD0-B82E-5A5B0DC1E224",
              );
            }

            currentStatus.showOption = true;
            currentStatus.selectedOption = currentStatus.selectOptions[0];

            console.log(
              "currentStatus.selectedOption",
              currentStatus.selectedOption,
            );
            _this.$forceUpdate();
          })
          .catch(function(error) {
            // handle error
            //console.log"error", error);
          });
      } else if (currentStatus.statusID === 605) {
        // ส่งเฝ้าระวัง
        // เพิ่มให้สามารถเลือกหน่วยงานตัวเองได้
        storeMaster
          .getDepartment(2)
          .then(function(response) {
              currentStatus.selectOptions = response.data.data.filter(
                (s) =>
                  // s.value !== userData.departmentId() &&
                  s.value !== "535e93cc-ad5a-488f-c410-08d86b48aba4",
              );

            // กรณีสิทธิ์เป็น `เจ้าหน้าที่`, `คัดกรอง` และ ธุรการกอง จะต้องไม่แสดง `กองกฏหมาย-บังคับคดี`
            const officerRole = userData.selectedUserRole().value.toUpperCase();
            if (
              officerRole === "5B70388F-7208-4F0A-BF76-F4D7DE349E92" || // เจ้าหน้าที่
              officerRole === "11857BDF-5691-45F1-823E-F5C3A6FD9FF4" || // คัดกรอง
              officerRole === "6F1AACD6-2EBA-4FB7-ABA2-02569990E5F4" // ธุรการกอง
            ) {
              currentStatus.selectOptions = currentStatus.selectOptions.filter(
                (s) =>
                  s.value.toUpperCase() !==
                    "A74DBA00-A697-4906-9125-260C8955275D" &&
                  s.value.toUpperCase() !==
                    "0351CA3F-4D3C-4FD0-B82E-5A5B0DC1E224",
              );
            }

            currentStatus.showOption = true;
            // default เป็นหน่วยงานที่ตัวเองอยู่ ถ้าไม่เจอในรายการให้ปล่อยว่าง
            currentStatus.selectedOption = _this.findOwnDepartmentOption(
              currentStatus.selectOptions
            );

            _this.$forceUpdate();
          })
          .catch(function(error) {
            console.log("error", error);
          });
      } else if (
        currentStatus.statusID === 11 ||
        currentStatus.statusID === 31 ||
        currentStatus.statusID === 81 ||
        currentStatus.statusID === 504
      ) {
        // หน่วยงานภายนอก
        storeMaster
          .getDepartment(1)
          .then(function(response) {
            // handle success
            ////console.log"response", response);
            currentStatus.selectOptions = response.data.data;
            // currentStatus.showOption = true;
            // currentStatus.selectedOption = currentStatus.selectOptions[0];

            currentStatus.selectOptions = _this.connectDataLink(
              response.data.data,
            );

            currentStatus.isMultiple = true;
            currentStatus.showOption = true;
            currentStatus.selectedOption = currentStatus.selectOptions[0];

            _this.$forceUpdate();
          })
          .catch(function(error) {
            // handle error
            //console.log"error", error);
          });
      } else if (
        currentStatus.statusID === 10 ||
        currentStatus.statusID === 80
      ) {
        // จังหวัด
        storeMaster
          .getProvince()
          .then(function(response) {
            // handle success
            // ////console.log"response", response);
            let provinces = response.data.data;
            if (provinces) {
              provinces = provinces.filter((value) => {
                if (value.value === "10") {
                  return false;
                }
                return true;
              });
            }
            currentStatus.selectOptions = provinces;
            currentStatus.selectedOption = currentStatus.selectOptions[0];
            currentStatus.showOption = true;
            _this.$forceUpdate();
          })
          .catch(function(error) {
            // handle error
            //console.log"error", error);
          });
      } else if (currentStatus.statusID === 17) {
        // ส่งต่อเจ้าหน้าที่
        const params = {
          departmentId: this.department.value,
        };

        departmentRoleStore
          .searchUser(params)
          .then(function(response) {
            // handle success
            ////console.log"response", response);

            var setDataList = [];

            response.data.data.forEach((o) => {
              var setData = {};
              setData.value = o.userId;
              setData.text = o.titleStr + " " + o.fName + " " + o.lName;

              setDataList.push(setData);
            });

            currentStatus.selectOptions = setDataList;
            currentStatus.selectedOption = currentStatus.selectOptions[0];
            currentStatus.showOption = true;
            _this.$forceUpdate();
          })
          .catch(function(error) {
            // handle error
            //console.log"error", error);
          });
      } else if (currentStatus.statusID === 121) {
        // จังหวัด
        storeMaster
          .getStatusGroup(userData.departmentId(), _this.$route.query.id)
          .then(function(response) {
            // handle success
            ////console.log"response", response);
            currentStatus.selectOptions = response.data.data;
            currentStatus.selectedOption = currentStatus.selectOptions[0];
            currentStatus.showOption = true;
            _this.$forceUpdate();
          })
          .catch(function(error) {
            // handle error
            //console.log"error", error);
          });
      } else if (currentStatus.statusID === 510) {
        // กทม เลือกเขต มีสำหรับแทบดำเนินการเท่านั้น
        storeMaster
          .getDistrict("10")
          .then(function(response) {
            // handle success
            // console.log("response", response);
            let districts = response.data.data;

            currentStatus.selectOptions = districts;
            currentStatus.selectedOption = currentStatus.selectOptions[0];
            currentStatus.showOption = true;
            _this.$forceUpdate();
          })
          .catch(function(error) {
            // handle error
            console.log("error", error);
          });
      } else if (currentStatus.statusID === 27) {
        this.comment = this.comment27;
        this.$forceUpdate();
      } else if (
        currentStatus.statusID === 514 ||
        currentStatus.statusID === 518
      ) {
        //ส่งต่อผู้ประกอบการและหน่วยงานภายใน (Fasttrack)
        storeMaster
          .getCompanySla()
          .then(function(response) {
            // handle success
            //console.log("response getCompanySla", response);
            //console.log("ComplainantCompany data", _this.complainantCompany);
            let companySla = response.data.data;

            currentStatus.selectOptions = companySla;
            // เลือก default ผู้ถูกร้องเรียนให้ dropdown
            if (
              currentStatus.selectOptions &&
              _this.complainantCompany &&
              _this.complainantCompany.length > 0
            ) {
              let defaultCompany = null;
              _this.complainantCompany.forEach((value) => {
                const defaultCompanyTmp = currentStatus.selectOptions.find(
                  (c) =>
                    c.compId?.toLowerCase() === value.compId?.toLowerCase(),
                );
                if (defaultCompanyTmp) {
                  defaultCompany = defaultCompanyTmp;
                  return;
                }
              });
              //console.log("defaultCompany", defaultCompany);
              // COMPLAINT-1534 ถ้าผู้ประกอบการของเรื่องไม่ได้อยู่ในรายชื่อบริษัทที่เข้าร่วม Fasttrack (MOU)
              // ต้องไม่ default เป็นบริษัทแรกในลิสต์ ให้เจ้าหน้าที่เลือกเองเพื่อกันการส่งผิดบริษัท
              currentStatus.selectedOption = defaultCompany
                ? defaultCompany
                : null;
            } else {
              currentStatus.selectedOption = null;
            }

            currentStatus.showOption = true;
            _this.$forceUpdate();
          })
          .catch(function(error) {
            // handle error
            console.log("error", error);
          });
        if (currentStatus.statusID === 514) {
          // หน่วยงานภายใน
          storeMaster
            .getDepartment(2)
            .then(function(response) {
              // handle success
              // console.log("response", response);
              currentStatus.selectOptions2 = response.data.data.filter(
                (s) =>
                  s.value !== userData.departmentId() &&
                  s.value !== "535e93cc-ad5a-488f-c410-08d86b48aba4",
              );

              // กรณีสิทธิ์เป็น `เจ้าหน้าที่`, `คัดกรอง` และ ธุรการกอง จะต้องไม่แสดง `กองกฏหมาย-บังคับคดี`
              const officerRole = userData
                .selectedUserRole()
                .value.toUpperCase();
              if (
                officerRole === "5B70388F-7208-4F0A-BF76-F4D7DE349E92" || // เจ้าหน้าที่
                officerRole === "11857BDF-5691-45F1-823E-F5C3A6FD9FF4" || // คัดกรอง
                officerRole === "6F1AACD6-2EBA-4FB7-ABA2-02569990E5F4" // ธุรการกอง
              ) {
                currentStatus.selectOptions2 = currentStatus.selectOptions2.filter(
                  (s) =>
                    s.value.toUpperCase() !==
                      "A74DBA00-A697-4906-9125-260C8955275D" &&
                    s.value.toUpperCase() !==
                      "0351CA3F-4D3C-4FD0-B82E-5A5B0DC1E224",
                );
              }

              currentStatus.showOption2 = true;
              currentStatus.selectedOption2 = currentStatus.selectOptions2[0];

              _this.$forceUpdate();
            })
            .catch(function(error) {
              // handle error
              console.log("error", error);
            });
        }
      } else if (currentStatus.statusID === 518) {
        //ส่งเรื่องไปยังผู้ประกอบการ (fastrack)
        storeMaster
          .getCompanySla()
          .then(function(response) {
            // handle success
            //console.log("response getCompanySla", response);
            //console.log("ComplainantCompany data", _this.complainantCompany);
            let companySla = response.data.data;

            currentStatus.selectOptions = companySla;
            // เลือก default ผู้ถูกร้องเรียนให้ dropdown
            if (
              currentStatus.selectOptions &&
              _this.complainantCompany &&
              _this.complainantCompany.length > 0
            ) {
              let defaultCompany = null;
              _this.complainantCompany.forEach((value) => {
                const defaultCompanyTmp = currentStatus.selectOptions.find(
                  (c) =>
                    c.compId?.toLowerCase() === value.compId?.toLowerCase(),
                );
                if (defaultCompanyTmp) {
                  defaultCompany = defaultCompanyTmp;
                  return;
                }
              });
              //console.log("defaultCompany", defaultCompany);
              if (defaultCompany) {
                currentStatus.selectedOption = defaultCompany;
              } else {
                currentStatus.selectedOption = currentStatus.selectOptions[0];
              }
            } else {
              currentStatus.selectedOption = currentStatus.selectOptions[0];
            }

            currentStatus.showOption = true;
            _this.$forceUpdate();
          })
          .catch(function(error) {
            // handle error
            console.log("error", error);
          });
      } else {
        this.comment = "";
        this.$forceUpdate();
        //_this.set('bTabs', _this.bTabs)
      }
    },
    selectOnInput() {
      //console.log"on input");
      this.$forceUpdate();
    },
    selectOnInputCategoryProcess() {
      //console.log"on input2");
      this.statusProcess = null;
      this.extendStatusProcessOptions = [];
      this.extendStatusProcess = null;
      this.groupProcess = null;
      this.comment = "";
      this.$forceUpdate();
    },
    selectOnInputGroupProcess() {
      //console.log"on input2");
      this.statusProcess = null;
      this.comment = "";
      this.$forceUpdate();
    },
    selectOnInputStatusProcess() {
      //_this.statusProcess.statusId
      var _this = this;

      //console.log"_this.statusProcess", _this.statusProcess);

      // if (_this.statusProcess.statusId === 9 || _this.statusProcess.statusId === 605) {
      if (_this.statusProcess.statusId === 9) {
        // หน่วยงานภายใน
        storeMaster
          .getDepartment(2)
          .then(function(response) {
            // handle success
            _this.extendStatusProcessOptions = response.data.data.filter(
              (s) =>
                s.value !== userData.departmentId() &&
                s.value !== "535e93cc-ad5a-488f-c410-08d86b48aba4",
            );

            // กรณีสิทธิ์เป็น `เจ้าหน้าที่`, `คัดกรอง` และ ธุรการกอง จะต้องไม่แสดง `กองกฏหมาย-บังคับคดี`
            const officerRole = userData.selectedUserRole().value.toUpperCase();
            if (
              officerRole === "5B70388F-7208-4F0A-BF76-F4D7DE349E92" || // เจ้าหน้าที่
              officerRole === "11857BDF-5691-45F1-823E-F5C3A6FD9FF4" || // คัดกรอง
              officerRole === "6F1AACD6-2EBA-4FB7-ABA2-02569990E5F4" // ธุรการกอง
            ) {
              _this.extendStatusProcessOptions = _this.extendStatusProcessOptions.filter(
                (s) =>
                  s.value.toUpperCase() !==
                  "A74DBA00-A697-4906-9125-260C8955275D",
              );
            }

            _this.extendStatusProcess = response.data.data.filter(
              (s) =>
                s.value !== userData.departmentId() &&
                s.value !== "535e93cc-ad5a-488f-c410-08d86b48aba4",
            )[0];

            _this.statusProcess.showOption = true;

            _this.$forceUpdate();
          })
          .catch(function(error) {
            // handle error
            //console.log"error", error);
          });
      } else if (_this.statusProcess.statusId === 605) {
        // หน่วยงานภายใน
        storeMaster
          .getDepartment(2)
          .then(function(response) {
            _this.extendStatusProcessOptions = response.data.data.filter(
              (s) =>
                // s.value !== userData.departmentId() &&
                s.value !== "535e93cc-ad5a-488f-c410-08d86b48aba4",
            );

            // กรณีสิทธิ์เป็น `เจ้าหน้าที่`, `คัดกรอง` และ ธุรการกอง จะต้องไม่แสดง `กองกฏหมาย-บังคับคดี`
            const officerRole = userData.selectedUserRole().value.toUpperCase();
            if (
              officerRole === "5B70388F-7208-4F0A-BF76-F4D7DE349E92" || // เจ้าหน้าที่
              officerRole === "11857BDF-5691-45F1-823E-F5C3A6FD9FF4" || // คัดกรอง
              officerRole === "6F1AACD6-2EBA-4FB7-ABA2-02569990E5F4" // ธุรการกอง
            ) {
              _this.extendStatusProcessOptions = _this.extendStatusProcessOptions.filter(
                (s) =>
                  s.value.toUpperCase() !==
                  "A74DBA00-A697-4906-9125-260C8955275D",
              );
            }

            _this.extendStatusProcess = response.data.data.filter(
              (s) =>
                // s.value !== userData.departmentId() &&
                s.value !== "535e93cc-ad5a-488f-c410-08d86b48aba4",
            )[0];

              currentStatus.showOption = true;
              // default เป็นหน่วยงานที่ตัวเองอยู่ ถ้าไม่เจอในรายการให้ปล่อยว่าง
              currentStatus.selectedOption = _this.findOwnDepartmentOption(
              currentStatus.selectOptions
            );          })
          .catch(function(error) {
            console.log("error", error);
          });
      } else if (
        _this.statusProcess.statusId === 11 ||
        _this.statusProcess.statusId === 31 ||
        _this.statusProcess.statusId === 504
      ) {
        // หน่วยงานภายนอก
        storeMaster
          .getDepartment(1)
          .then(function(response) {
            // handle success
            ////console.log"response", response);
            _this.extendStatusProcessOptions = response.data.data;
            _this.extendStatusProcess = response.data.data[0];
            _this.extendStatusProcessOptions = _this.connectDataLink(
              response.data.data,
            );
            _this.statusProcess.showOption = true;

            _this.$forceUpdate();
          })
          .catch(function(error) {
            // handle error
            //console.log"error", error);
          });
      } else if (
        _this.statusProcess.statusId === 10 ||
        _this.statusProcess.statusId === 10
      ) {
        // จังหวัด
        storeMaster
          .getProvince()
          .then(function(response) {
            // handle success
            //////console.log"response", response);
            let provinces = response.data.data;
            if (provinces) {
              provinces = provinces.filter((value) => {
                if (value.value === "10") {
                  return false;
                }
                return true;
              });
            }
            _this.extendStatusProcessOptions = provinces;
            _this.extendStatusProcess = provinces[0];

            _this.statusProcess.showOption = true;

            _this.$forceUpdate();
          })
          .catch(function(error) {
            // handle error
            //console.log"error", error);
          });
      } else if (_this.statusProcess.statusId === 17) {
        // ส่งต่อเจ้าหน้าที่
        const params = {
          departmentId: this.department.value,
        };

        departmentRoleStore
          .searchUser(params)
          .then(function(response) {
            // handle success
            ////console.log"response", response);

            var setDataList = [];

            response.data.data.forEach((o) => {
              var setData = {};
              setData.value = o.userId;
              setData.text = o.titleStr + " " + o.fName + " " + o.lName;

              setDataList.push(setData);
            });

            _this.extendStatusProcessOptions = setDataList;
            _this.extendStatusProcess = setDataList[0];

            _this.statusProcess.showOption = true;

            _this.$forceUpdate();
          })
          .catch(function(error) {
            // handle error
            //console.log"error", error);
          });
      } else if (_this.statusProcess.statusId === 27) {
        _this.comment = this.comment27;
      } else {
        _this.comment = "";
        _this.extendStatusProcessOptions = [];
        _this.extendStatusProcess = null;
        _this.statusProcess.showOption = false;
      }
    },
    filterAttachFile(type) {
      try {
        if (this.attachFiles === undefined) return [];

        const filterAttach = this.attachFiles.filter((value) => {
          return value.typeUserUpload === type;
        });

        return filterAttach;
      } catch (ex) {
        return [];
      }
    },
    filterTrackingDetailAttachFile(trackingDetailId) {
      try {
        if (this.trackingDetailAttachFiles === undefined) {
          return [];
        }

        const filterAttach = this.trackingDetailAttachFiles.filter((value) => {
          return value.trackingDetailId === trackingDetailId;
          //return true
        });

        //console.log"filterAttach", filterAttach);

        return filterAttach;
      } catch (ex) {
        return [];
      }
    },
    getStatusHistory(statusId) {
      try {
        const _this = this;

        if (this.trackings === undefined || this.trackings === null) return [];

        let results = [];

        ////console.log'_this.trackings', _this.trackings)

        _this.trackings.forEach((value1, index1) => {
          if (value1.detailList !== null && value1.detailList !== undefined) {
            if (value1.departmentId == userData.departmentId()) {
              value1.detailList.forEach((value2, index2) => {
                if (value2.lv !== null && value2.lv !== undefined) {
                  value2.lv.forEach((value3, index3) => {
                    if (value3.st !== null && value3.st !== undefined) {
                      value3.st.forEach((value4, index4) => {
                        if (value4.statusID === statusId) {
                          ////console.log'push', value2.createTrackingStr)
                          const trackingObj = {
                            createTrackingDateStr: value2.createTrackingDateStr,
                            comment: value2.comment,
                          };
                          results.push(trackingObj);
                        }
                      });
                    }
                  });
                }
              });
            }
          }
        });

        return results;
      } catch (ex) {
        //console.log"status ex", ex);
        return [];
      }
    },
    getFileType() {
      //console.log"getFileType");
      const _this = this;

      storeMaster
        .getMasterByType()
        .then(function(response) {
          // handle success
          ////console.log'then', response);

          var convertData = response.data.data.map(function(item, index) {
            return {
              value: item.masterId,
              text: item.description,
            };
          });

          _this.attachTypes = convertData;
        })
        .catch(function(error) {
          // handle error
          //console.log"error", error);
        })
        .then(function() {
          // always executed
        });
    },
    onUploadFileChangedAdditional(e) {
      const selectedFiles = e.target.files;
      if (
        selectedFiles === null ||
        selectedFiles === undefined ||
        selectedFiles.length <= 0
      ) {
        return;
      }

      const _this = this;
      this.file3Overlay = true;

      var isMissing = this.onValidateExtensionFiles(selectedFiles, null);
      if (isMissing === true) {
        this.file3Overlay = false;
        return;
      }

      selectedFiles.forEach(function(value, index) {
        //console.log"value", value);
        // console.log("righttabaction.onuploadfilechangedadditional.value", value);
        _this.createBase64ImageAdditional(value);
      });
    },
    createBase64ImageAdditional(fileObject) {
      const _this = this;
      const reader = new FileReader();

      const fileName = fileObject.name;
      const fileSize = fileObject.size;

      reader.onload = (e) => {
        const fileBase64 = e.target.result;
        //console.log
        //   "fileName=",
        //   fileName,
        //   "fileSize=",
        //   fileSize,
        //   "fileType=",
        //   _this.selected
        // );
        this.$refs["file-input3"].reset();

        const data = [
          {
            fileName: fileName,
            fileSize: fileSize,
            fileBase64: fileBase64,
            userId: userData.userId(),
            masterId: _this.selected,
            fileType: _this.selected,
          },
        ];
        storeFileUpload
          .uploadFile(data)
          .then(function(response) {
            // handle success
            //console.logresponse);
            // console.log(response);
            response.data.data.forEach(function(value, index) {
              ////console.log'emit upload', value)
              //this.$emit('handleSend', id)
              _this.emitAdditionalUploadFile(value);
            });
          })
          .catch(function(error) {
            // handle error
            //console.log"error", error);
          })
          .then(function() {
            // always executed
            _this.file3Overlay = false;
          });
      };

      reader.readAsDataURL(fileObject);
    },
    emitAdditionalUploadFile(file) {
      this.additionalAttachFiles.push(file);
    },
    onAdditionalAttachFileDelete(id) {
      const file = this.additionalAttachFiles.find(function(value) {
        return value.attachId === id;
      });

      var filteredAry = this.additionalAttachFiles.filter(
        (o) => o.attachId != id,
      );

      this.additionalAttachFiles = filteredAry;
    },
    isShowAdditionalFile() {
      try {
        const _this = this;
        const tab = this.bTabs.find(function(value) {
          return value.tab.id === _this.selectedTab;
        });
        let currentStatus = tab.statusModel.find(function(value) {
          return value.statusID === tab.selectedStatus;
        });
        if (currentStatus.statusID === 98) {
          return true;
        }
        return false;
      } catch (ex) {
        return false;
      }
    },
    isDepartmentValid() {
      const isResult = true;
      try {
        if (this.isComplaintGrp == false) {
          // default is true
          if (this.lastTrackingData.departmentId == null) {
            isResult = true;
          }
          if (
            this.lastTrackingData.departmentId.toLowerCase() !==
            userData.departmentId().toLowerCase()
          ) {
            isResult = false;
          }
        }
        //console.log"isDepartmentValid succ", isResult);
        return isResult;
      } catch (ex) {
        //console.log"isDepartmentValid catch", isResult, ex);
        return isResult;
      }
    },
    getLastTracking(id) {
      const _this = this;

      storeTracking
        .getLastTracking(id)
        .then(function(response) {
          // handle success
          //console.log"getLastTracking", response);
          // console.log("getLastTracking", response);

          _this.lastTrackingData = response.data.data;
        })
        .catch(function(error) {
          // handle error
          //console.log"error", error);
        })
        .then(function() {
          // always executed
        });
    },
    getClueLastTracking(id) {
      //console.log"getClueLastTracking");
      const _this = this;
      storeTracking
        .getClueLastTracking(id)
        .then(function(response) {
          // handle success
          //console.log"getClueLastTracking", response);
          // console.log("getClueLastTracking", response);

          _this.lastTrackingData = response.data.data;
        })
        .catch(function(error) {
          // handle error
          //console.log"error", error);
        })
        .then(function() {
          // always executed
        });
    },
    connectDataLink(data) {
      var setDataList = [];
      data.forEach((o) => {
        var setData = {};
        if (o.dataLink == true) {
          setData.value = o.value;
          setData.text = "(เชื่อมโยง) " + o.text;
          setData.provincialLevel = o.provincialLevel;
        } else {
          setData = o;
        }
        setDataList.push(setData);
      });
      return setDataList;
    },
    isDetrctProvincalLevel(data) {
      if (Array.isArray(data)) {
        // 👇️ this runs
        const detectedLevel2 =
          data.length > 0 &&
          data.some((value) => {
            return value.provincialLevel > 1;
          });
        const detectedLevel1 =
          data.length > 0 &&
          data.some((value) => {
            return value.provincialLevel > 0;
          });

        if (detectedLevel2) {
          return 2;
        } else if (detectedLevel1) {
          return 1;
        } else {
          return 0;
        }
      } else {
        return 0;
      }
    },
    isDocumentInProgress(item, rad) {
      if (
        rad.docCode !== null ||
        item.statusModel.filter((o) => o.docCode !== null && o.statusID !== 316) // 316 บันทึกมูลค่าความเสียหาย
          .length > 0
      ) {
        // console.log("DocumentInProgress");
        return true;
      }
      // หากไม่ยินยอมส่งข้อมูลให้ fasttrack ให้ disable ปุ่ม
      if (
        (rad.statusID == 514 || rad.statusID == 518) &&
        !this.complaintData?.fastTrackAllowance?.isAllowFastTrack
      ) {
        return true;
      }
      return false;
    },
    statusDescriptionRemoveNumber(description) {
      try {
        let indexOfDot = description.indexOf(".");
        let descriptionNumberRemove = description.slice(indexOfDot + 1);
        // //console.log"indexOfDot", indexOfDot, descriptionNumberRemove);
        return descriptionNumberRemove;
      } catch (ex) {
        return description;
      }
    },
    propsConsole() {
      const _this = this;

      //console.log"propsConsole componentName", this.backComponentName);
      //console.log"propsConsole $route.query.id", _this.$route.query.id);
      //console.log"propsConsole complaintId", this.complaintId);
      //console.log"propsConsole isComplaintGrp", this.isComplaintGrp);
      // console.log("propsConsole componentName", this.backComponentName);
      // console.log("propsConsole $route.query.id", _this.$route.query.id);
      // console.log("propsConsole complaintId", this.complaintId);
      // console.log("propsConsole isComplaintGrp", this.isComplaintGrp);

      const emptyGuid = "00000000-0000-0000-0000-000000000000";
      // const test = uuidv4();
      // const uuid = require('uuid');
      // const emptyGuid = Guid.Empty();
      //console.log"propsConsole guid.empty", emptyGuid);
      // console.log("propsConsole guid.empty", emptyGuid);
    },
    getExtendProvinces() {
      const _this = this;
      storeMaster
        .getProvince()
        .then(function(response) {
          // handle success
          ////console.log"response", response);
          // console.log("response", response);
          _this.extendProvinceOptions = response.data.data;
          _this.$forceUpdate();
        })
        .catch(function(error) {
          // handle error
          //console.log"error", error);
        });
    },
    selectExtendStatusProcessInput(e) {
      //console.log"selectExtendStatusProcessInput", e);
      const _this = this;
      if (e) {
        if (e.provincialLevel > 0) {
          _this.extendProvinceSelected = null;
          _this.extendDistrictSelected = null;
        }
      }
    },
    selectExtendStatusProcessProvinceInput(e) {
      //console.log
      //   "selectExtendStatusProcessProvinceInput",
      //   e,
      //   this.extendProvinceSelected
      // console.log(
      //   "selectExtendStatusProcessProvinceInput",
      //   e,
      //   this.extendProvinceSelected,
      // );
      this.$forceUpdate();
      const _this = this;
      if (e) {
        storeMaster.getDistrict(e.value).then((response) => {
          _this.extendDistrictOptions = response.data.data;
          _this.extendDistrictSelected = null;
        });
      }
    },
    selectExtendStatusProcessDistrictInput(e) {
      //console.log"selectExtendStatusProcessDistrictInput", e);
      this.$forceUpdate();
    },
    selectRadOptionInput(e) {
      //console.log"selectRadOptionInput", e);
      // console.log("selectExtendStatusProcessDistrictInput", e);
      this.$forceUpdate();
    },
    selectRadOptionInput(e) {
      // console.log("selectRadOptionInput", e);
      this.$forceUpdate();
    },
    onValidateExtensionFiles(selectedFiles, section) {
      // console.log(`righttabaction.onvalidateextensionfiles.section`, section);
      let isMissing = false;

      // เช็คว่าไฟล์ที่อัพโหลดมีสกุลไฟล์หรือไม่
      // ถ้าไม่มีให้แสดง popup แจ้งเตือน
      const arrNoExtension = Object.values(selectedFiles).filter((file) => {
        return (
          file.type === null || file.type === undefined || file.type === ""
        );
      });
      // console.log(
      //   "righttabaction.onvalidateextensionfiles.arrnoextension",
      //   arrNoExtension
      // );
      if (arrNoExtension.length > 0) {
        isMissing = true;
        this.$swal({
          html:
            "<div>ไม่สามารถอัพโหลดไฟล์ที่ไม่มีสกุลไฟล์ได้<br />กรุณาตรวจสอบไฟล์ของท่านก่อนทำการอัพโหลด</div>",
          icon: "warning",
          showCancelButton: false,
          confirmButtonText: "ตกลง",
          customClass: {
            confirmButton: "btn btn-danger",
          },
        }).then((result) => {
          // console.log(
          //   "righttabaction.onvalidateextensionfiles.fileinput",
          //   this.$refs["file-input"]
          // );
          // console.log(
          //   "righttabaction.onvalidateextensionfiles.fileinput2",
          //   this.$refs["file-input2"]
          // );
          try {
            this.$refs["file-input"].reset();
            this.$refs["file-input2"].reset();
          } catch (ex) {
            console.log(ex);
          }
        });
      }

      return isMissing;
    },
    onMainTabClicked(id) {
      /* ถ้าเป็น statusid = 27 ให้เพิ่ม default comment */
      // console.log('this', this);
      const selecttab = this.selectedTab;
      const Setcomment27 = this.comment27;
      var SetCommentcommon = this.comment;
      if (id === 0) {
        // console.log(1111);
        this.bTabs.find(function(value) {
          if (value.tab.id === selecttab) {
            // console.log(2222);
            if (value.selectedStatus === 27) {
              // console.log(3333);
              SetCommentcommon = Setcomment27;
            } else {
              SetCommentcommon = "";
              // console.log(4444);
            }
          }
        });
      } else {
        if (this.statusProcess != null && this.statusProcess.statusId === 27) {
          // console.log(5555);
          SetCommentcommon = Setcomment27;
        } else {
          // console.log(6666);
          SetCommentcommon = "";
        }
      }
      this.comment = SetCommentcommon;
      this.tabIndex = id;
    },
    onSetOnFastTrack(val) {
      this.onFastTrack = val;
      //this.onFastTrack = true;
    },
    getSimilarComplaint(id) {
      const _this = this;

      storeComplaint
        .getSimilarComplaint(id)
        .then(function(response) {
          // handle success
          // console.log("getSimilarComplaint", response);

          if (
            response.status &&
            response.data != null &&
            response.data.data != null
          ) {
            _this.similarComplaintData = response.data.data;
          } else {
            _this.similarComplaintData = [];
          }

          // console.log("getSimilarComplaint", _this.similarComplaintData);
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        })
        .then(function() {
          // always executed
        });
    },
    downloadFasttrackAttachFile(attachFile, companyId) {
      try {
        // console.log("downloadFasttrackAttachFile", attachFile, companyId);
        storeTracking
          .getFasttrackAttachFile(attachFile.attachFileId, companyId)
          .then((response) => {
            if (response && response.status === 200) {
              const url = window.URL.createObjectURL(new Blob([response.data]));

              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", attachFile.fileName);

              document.body.appendChild(link);
              link.click();
              link.remove();
            }
          });
      } catch (ex) {
        console.log("downloadFasttrackFile ex", ex);
      }
    },
    onAppointmentMediateClick(meetingData) {
      // console.log(
      //   "onAppointmentMediateClick",
      //   this.$refs,
      //   this.$refs["modal-mediate-appointment-detail"],
      // );
      this.$refs["modal-mediate-appointment-detail"].setModalData(
        this.complaintId,
        meetingData,
      );
      this.$refs["modal-mediate-appointment-detail"].$refs[
        "modal-mediate-appointment-detail"
      ].show();
    },
  },
};
</script>

<style scoped>
[dir] .dark-layout .border-custom-dark {
  border-color: #d0d2d6 !important;
}
.tooltip {
  /* position: relative; */
  display: inline-flex;
  align-items: center;
  /* cursor: pointer; */
  opacity: 1 !important;
}
.tooltip svg {
  color: #747474;
}
.tooltip-text {
  visibility: hidden;

  width: 280px;
  background-color: #333;
  color: #fff;
  text-align: left;
  border-radius: 6px;
  padding: 8px 10px;
  position: absolute;
  z-index: 1;
  bottom: 125%;
  left: 50%;
  transform: translateX(-50%);
  transition: opacity 0.2s;
  font-size: 14px;
  line-height: 1.4;
}
.tooltip:hover .tooltip-text {
  visibility: visible;
  opacity: 1;
}
.tooltip-text::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border-width: 5px;
  border-style: solid;
  border-color: #333 transparent transparent transparent;
}

.fasttrack-grid {
  display: grid;
  grid-template-columns: 200px 1fr;
  gap: 6px;
  text-align: left;
}

/* allow grid items to shrink inside the grid */
/* .fasttrack-grid > div {
  min-width: 0;
} */

/* wrap long words across lines (recommended) */
/* .fasttrack-grid label,
.fasttrack-grid div {
  overflow-wrap: break-word;
  word-break: break-word;
  hyphens: auto;
} */

.custom-tooltip {
  position: relative;
  display: inline-block;
  margin-left: 6px;
  cursor: pointer;
}

.custom-tooltip .tooltip-text {
  visibility: hidden;
  width: 220px;
  background-color: #333;
  color: #fff;
  text-align: left;
  border-radius: 6px;
  padding: 8px;
  font-size: 12px;

  position: absolute;
  z-index: 1;
  bottom: 125%;
  left: 50%;
  transform: translateX(-50%);

  opacity: 0;
  transition: opacity 0.3s;
}

.custom-tooltip:hover .tooltip-text {
  visibility: visible;
  opacity: 1;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
